<template>
	<div class="k-case-item-importer mt-0">
		<div class="pt-1 mt-2 d-flex" style="border-top: 1px solid #999; color: black; font-size: 18px">
			<b>Batch Import Child Items</b>
			<k-spacer/>
			<k-btn x-small class="ml-2 mt-1 k-tight-btn" color="secondary" @click="ai_import_interface_showing = true">Using AI</k-btn>
			<k-btn x-small class="ml-2 mt-1 k-tight-btn" color="secondary" @click="import_from_cc">From CC</k-btn>
			<k-btn x-small class="ml-2 mt-1 k-tight-btn" color="secondary" @click="pdf_import_interface_showing = true">From PDF</k-btn>
			<k-btn x-small class="ml-4 mt-1 k-tight-btn" color="primary" @click="show_advanced_options = !show_advanced_options">Options</k-btn>
		</div>
		<ItemPDFImportInterface v-if="pdf_import_interface_showing"
			:editor_component="this"
			@cancel_import="pdf_import_interface_showing = false" 
			@paste_contents="
				contents => {
					raw_text_for_import = contents;
					pdf_import_interface_showing = false;
				}
			"
		/>
		<ItemAIImportInterface v-if="ai_import_interface_showing"
			:editor_component="this"
			@cancel_import="ai_import_interface_showing = false" 
			@paste_contents="
				contents => {
					raw_text_for_import = contents;
					ai_import_interface_showing = false;
				}
			"
		/>

		<ResourceAIImportInterface v-if="resource_ai_import_interface_showing"
			:editor_component="this"
			@cancel_import="resource_ai_import_interface_showing = false"
			@paste_contents="
				contents => {
					raw_text_for_import = contents;
					resource_ai_import_interface_showing = false;
				}
			"
			@add_item="resource_add_item"
		/>

		<div v-show="show_advanced_options" class="mt-2">
			<div class="k-case-ie-line d-flex align-center py-1">
				<div class="k-case-ie-line-label mr-2">Delimiter:</div>
				<k-radio-group v-model="delimiter" hide-details row>
					<k-radio style="margin-top: -24px" label="Any whitespace character" value="spaces"></k-radio>
					<k-radio style="margin-top: -24px" label="Tabs only" value="tabs"></k-radio>
				</k-radio-group>
			</div>
			<div class="k-case-ie-line d-flex">
				<div class="mr-2">“Pre-Script”:</div>
				<div>
					<k-select v-model="pre_script" :items="pre_script_select_items" label="" dense outlined
						hide-details></k-select>
				</div>
			</div>
			<div class="k-case-ie-line d-flex">
				<div class="mr-2">“Post-Script”:</div>
				<div>
					<k-select v-model="post_script" :items="post_script_select_items" label="" dense outlined
						hide-details></k-select>
				</div>
			</div>
			<div class="k-case-ie-line">
				<div style="flex: 1 1 auto">
					<div class="k-case-ie-line-label">Parsing algorithm:</div>
					<k-radio-group v-model="parse_algo" hide-details class="mt-0 ml-2">
						<k-radio background-color="#fff" class="mb-1"
							value="algo1"
							label="1. Each line is always parsed as a competency"
						></k-radio>
						<k-radio background-color="#fff" class="mb-1"
							value="algo2"
							label="2. Only process lines that start with human-readable codes (admin only)"
						></k-radio>
					</k-radio-group>

					<k-checkbox class="mt-2 ml-2 pt-0" hide-details
						v-model="convert_newlines_to_spaces"
						:label="'Convert newlines to spaces'"
					></k-checkbox>
					<k-checkbox class="mt-2 ml-2 pt-0" hide-details
						v-model="no_hierarchy"
						:label="'Update existing items only (ignore new items and item hierarchy)'"
					></k-checkbox>
					<div v-if="no_hierarchy" class="ml-5">
						<k-checkbox class="mt-2 ml-2 pt-0" hide-details
							v-model="use_hcs_for_hierarchy"
							:label="'Use Human Readable Code instead of identifier for item matching'"
						></k-checkbox>
					</div>
				</div>
			</div>

			<div class="k-case-ie-line" v-show="parse_algo == 'algo2'">
				<div class="k-case-ie-line-label mr-3 text-right">Human-Readable<br />Code Stem (e.g. “AFNR”):</div>
				<k-text-field background-color="#fff" outlined dense hide-details v-model="hcs_prefix" placeholder=""
					autocomplete="new-password" clearable></k-text-field>
			</div>

			<div class="mt-1" v-show="parse_algo == 'algo1'">
				Sample import lines:

				<pre v-if="delimiter == 'spaces'" class="elevation-2 pa-1 mt-1 mb-2" style="border-radius: 6px; border: 1px solid #ccc">
Course * :41.01400 Grade 3
Knowledge_Domain ** Earth and Space Science
S *** :S3E1 Obtain, evaluate, and communicate information...
E **** :S3E1.a Ask questions and analyze data to...
</pre>

				<pre v-if="delimiter == 'tabs'" class="elevation-2 pa-1 mt-1 mb-2" style="border-radius: 6px; border: 1px solid #ccc">
Course   Grade 3
   Knowledge Domain   Earth and Space Science
      Standard   :S3E1 Obtain, evaluate, and communicate...
         Element   :S3E1.a Ask questions and analyze data to...
</pre>

			</div>
		</div>
		<div v-if="!show_advanced_options && pre_script" class="mt-1 red--text text--darken-2">
			<ul><li>Running Pre-Script: <b>{{pre_script_select_items.find(x => x.value == pre_script).text}}</b></li></ul>
		</div>
		<div v-if="!show_advanced_options && post_script" class="mt-1 red--text text--darken-2">
			<ul><li>Running Post-Script: <b>{{post_script_select_items.find(x => x.value == post_script).text}}</b></li></ul>
		</div>

		<div class="mt-1 pt-2 text-center" style="border-top: 1px solid #999">
			Paste item text below, then click “PROCESS...” to continue.
		</div>
		<div class="d-flex align-center mt-2 mb-3">
			<k-btn small color="secondary" class="mr-2" @click="$emit('cancel_import')">Cancel Import</k-btn>
			<k-btn small color="primary" @click="import_children">Process Imported Item Text…</k-btn>
			<k-spacer />
			<k-btn small color="#333" dark fab class="ml-2" accessible-label="Expand imported item text editor" @click="ta_dialog_open = true"><k-icon>fas fa-expand</k-icon></k-btn>
		</div>
		<k-textarea background-color="#fff" class="k-case-item-importer-raw-text-area" outlined dense autofocus hide-details placeholder="" accessible-label="Imported item text" rows="20"
			v-model="raw_text_for_import"
		></k-textarea>

		<k-dialog v-model="ta_dialog_open" max-width="95vw" persistent scrollable aria-label="Expanded imported item text editor" @keydown.esc="ta_dialog_open = false">
			<k-card style="background-color: #eee">
				<k-card-text>
					<div class="mt-4" v-show="parse_algo == 'algo1'">

						<pre class="elevation-2 pa-1 mt-1 mb-2 white" style="border-radius: 6px; border: 1px solid #ccc">
Course * :41.01400 Grade 3
Knowledge_Domain ** Earth and Space Science
NOTES: These are the standards for Earth and Space Science...
S *** :S3E1 Obtain, evaluate, and communicate information...
E **** :S3E1.a Ask questions and analyze data to...
EX:
---
Supplemental Info Heading

This is the text of the supplemental info...
</pre>

					</div>
					<div class="d-flex align-center mt-2 mb-3">
						<k-btn small color="secondary" class="mr-2" @click="ta_dialog_open = false; $emit('cancel_import');">Cancel Import</k-btn>
						<k-btn small color="primary" @click="import_children">Process Imported Item Text…</k-btn>
						<k-spacer />
						<k-btn small color="#333" dark fab class="ml-2" accessible-label="Collapse imported item text editor" @click="ta_dialog_open = false"><k-icon>fas fa-compress</k-icon></k-btn>
					</div>
					<k-textarea background-color="#fff" class="k-case-item-importer-raw-text-area-max" autofocus outlined dense hide-details placeholder="" accessible-label="Expanded imported item text" rows="40"
						v-model="raw_text_for_import"
					></k-textarea>
				</k-card-text>
			</k-card>
		</k-dialog>
	</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import ItemPDFImportInterface from './ItemPDFImportInterface'
import ItemAIImportInterface from './ItemAIImportInterface'
import ResourceAIImportInterface from './ResourceAIImportInterface'
import ImportFromCCMixin from './ImportFromCCMixin'
import { isReactive } from 'vue';

export default {
	components: { ItemPDFImportInterface, ItemAIImportInterface, ResourceAIImportInterface },
	mixins: [ImportFromCCMixin],
	props: {
		editor_component: { required: true },
		educationLevel: {
			type: Array,
			required: false,
			default() {
				return []
			}
		},
		language: {
			type: String,
			required: false,
			default() {
				return ''
			}
		}
	},
	data() {
		return {
			hcs_prefix: '',
			raw_text_for_import: '',
			pre_script_select_items: [
				{ value: '', text: 'None' },
				{ value: 'pre_script_edsby_course_import', text: 'Edsby course import' },
				{ value: 'pre_script_cl_evidence_statements_import', text: 'CL ES import' },
				{ value: 'pre_script_sc_course_code_import', text: 'South Carolina course codes import' },
				{ value: 'pre_script_asn', text: 'ASN import' },
				{ value: 'pre_script_australia', text: 'Australia import' },
				{ value: 'pre_script_cps_tfg_link', text: 'CPS TFG link import' },
				{ value: 'pre_script_cps_tfg_lesson_data', text: 'CPS TFG: extract lesson data' },
				{ value: 'pre_script_resource_full_text_import', text: 'Resource Full Text Import' },
				{ value: 'pre_script_resource_summary_import', text: 'Resource Summary Import' },
			],
			post_script_select_items: [
				{ value: '', text: 'None' },
				{ value: 'post_script_ccsd_unit', text: 'Columbia County SD - Units' },
				{ value: 'post_script_ccsd_module', text: 'Columbia County SD - Modules' }
			],

			// TODO: gui controls for these
			hcs_prefix_number_separator: '-',
			create_trees: true,
			statement_options: 'single_line', // or 'multiple_lines'
			read_to_period: true,
			order_by_hcs: true,
			algo2_item_types: ['Standard', 'Element'],
			bullet_continues_item: false,
			ta_dialog_open: false,
			no_hierarchy: false,
			use_hcs_for_hierarchy: false,
			pdf_import_interface_showing: false,
			ai_import_interface_showing: false,
			resource_ai_import_interface_showing: false,

			meta_params: {},
		}
	},
	computed: {
		...mapState(['user_info', 'recommended_max_cfitems']),
		...mapGetters([]),
		// note that show_advanced_options and convert_newlines_to_spaces are in the store directly, not lst, so they will be reset when the user reloads
		show_advanced_options: {
			get() {
				return this.$store.state.import_interface_show_advanced_options
			},
			set(val) {
				this.$store.commit('set', ['import_interface_show_advanced_options', val])
			}
		},
		convert_newlines_to_spaces: {
			get() {
				return this.$store.state.import_interface_convert_newlines_to_spaces
			},
			set(val) {
				this.$store.commit('set', ['import_interface_convert_newlines_to_spaces', val])
			}
		},
		delimiter: {
			get() {
				return this.$store.state.lst.import_delimiter
			},
			set(val) {
				this.$store.commit('lst_set', ['import_delimiter', val])
			}
		},
		pre_script: {
			get() {
				let ps = this.$store.state.lst.import_pre_script
				if (this.pre_script_select_items.find(x => x.value == ps)) return ps
				else return ''
			},
			set(val) {
				this.$store.commit('lst_set', ['import_pre_script', val])
			}
		},
		post_script: {
			get() {
				let ps = this.$store.state.lst.import_post_script
				if (this.post_script_select_items.find(x => x.value == ps)) return ps
				else return ''
			},
			set(val) {
				this.$store.commit('lst_set', ['import_post_script', val])
			}
		},
		parse_algo: {
			get() {
				// system admins can choose between algo1 and algo2; for other users, just use algo1
				if (this.user_info.system_role == 'admin') return this.$store.state.lst.import_parse_algo
				else return 'algo1'
			},
			set(val) {
				this.$store.commit('lst_set', ['import_parse_algo', val])
			}
		}
	},
	watch: {},
	created() {
		vapp.item_import_component = this
	},
	mounted() {},
	methods: {
		editor_config() {
			let config = U.get_froala_config({
				// placeholderText: '',
				enter: FroalaEditor.ENTER_BR,
				heightMin: 420,
				pastePlain: true, // doesn't seem to do what I want it to do
				editorClass: 'k-froala-plain-text',
				toolbarButtons: ['bold', 'italic', 'clearFormatting', 'html', 'fullscreen']
				// toolbarButtons: {
				// 	moreRich: {buttons: ['bold', 'italic', 'insertLink', 'insertImage',
				// 		'underline', 'strikeThrough', 'subscript', 'superscript', 'fontSize', 'textColor', 'backgroundColor', 'align',]
				// 		, buttonsVisible: 8},	// , 'quote', 'outdent', 'indent'
				// 	moreMisc: {buttons: ['fullscreen', 'paragraphFormat', 'insertVideo', 'specialCharacters', 'formatUL', 'formatOL', 'insertHR', 'insertTable', 'clearFormatting', 'html'], buttonsVisible: 1, align:'right'}
				// },
			})
			return config
		},
		async import_children() {
			////////////////////////////////

			// internal fn for processing cfitems
			let process_cfitem = (line_number, hcs, full_statement) => {
				// for algo2, see if this is a duplicate
				let prev_cfitem = cfitems.find(x => x.humanCodingScheme == hcs)
				if (this.parse_algo == 'algo2' && !empty(prev_cfitem)) {
					// if we found an already-processed standard with the same hcs, check to see if the full_statements are the same
					if (prev_cfitem.fullStatement == full_statement) {
						log.push(
							sr(
								'$1: Duplicate competency found; statements match <span style="color:#999">[$2]</span>',
								line_number,
								hcs
							)
						)
					} else {
						process_error(
							line_number,
							sr(
								'Found duplicate competency for $1 with different statement. <span style="color:#999"><b>Original:</b> $2 / <b>New:</b> $3</span>',
								hcs,
								prev_cfitem.fullStatement,
								full_statement
							)
						)
					}
					return
				}

				// if second arg (hcs) is an object, it should include all the properties we want to set
				let cfitem
				if (typeof hcs == 'object') {
					// in this case, if we received an identifier and an item with that identifier already exists, start with the existing item
					if (hcs.identifier) {
						cfitem = this.editor_component.framework_record.cfo.cfitems[hcs.identifier]
						if (cfitem) {
							// this copies the data in the existing cfitem
							cfitem = new window.CFItem(cfitem).to_json()
							// change/add any values in hcs
							for (let prop in hcs) {
								// for extensions we have to copy props of the extensions
								if (prop == 'extensions') {
									if (empty(cfitem.extensions)) cfitem.extensions = {}
									for (let extprop in hcs.extensions) {
										cfitem.extensions[extprop] = hcs.extensions[extprop]
									}
								} else {
									cfitem[prop] = hcs[prop]
								}
							}
						}
					}

					// if we didn't find an existing cfitem, just use the hcs object
					if (!cfitem) cfitem = hcs
				} else {
					cfitem = {
						humanCodingScheme: hcs,
						fullStatement: full_statement,
						extensions: {}
					}
				}

				cfitems.push(cfitem)
				log.push(
					sr('$1: Competency processed: <span style="color:#999">[$2]</span>', line_number, cfitem.fullStatement)
				)

				// return cfitem
				return cfitem
			}

			// internal fn for processing markdown
			let process_markdown = line => {
				// if convert_newlines_to_spaces, clean up spaces -- reduce any number of space chars to a single space (lines never include \n's) -- but leave tabs alone
				if (this.convert_newlines_to_spaces) line = line.replace(/ +/g, ' ')

				// replace starting bullets with *
				line = line.replace(/^[•●]/, '*')

				// replace starting 'o's with '    *' (four spaces), which makes it a nested list
				line = line.replace(/^o\s+/, '    * ')

				return line
			}

			// internal fn for processing errors
			let process_error = (line_number, error) => {
				log.push(
					sr(
						'<div class="my-3">$1: <b class="red" style="padding:3px 3px; border-radius:3px; color:#fff;">Error:</b> $2</div>',
						line_number,
						error
					)
				)
				++error_count
			}

			// internal fn for processing non-error info
			let process_info = (line_number, statement) => {
				log.push(sr('$1: $2', line_number, statement))
			}

			////////////////////////////////

			// THIS WAS FOR FROALA, which we're not doing anymore
			// convert <br>s (with surrounding space) to line breaks; marked will convert everything back to neat paragraphs
			// let lines = $.trim(this.raw_text_for_import.replace(/\s*<br.*?>\s*/g, '\n'))
			let lines = $.trim(this.raw_text_for_import)
			if (empty(lines) && !this.pre_script) {
				this.$alert('You must enter item text to import.')
				return
			}

			this.hcs_prefix = $.trim(this.hcs_prefix)
			if (this.parse_algo == 'algo2' && empty(this.hcs_prefix)) {
				this.$alert(
					'For parsing algorithm 2, you must enter a “Human-Readable Code Stem”. For example, if the codes for the competencies you’re importing have the format “AFNR-BAS-1”, “AFNR-BAS-1.1”, etc., use “ANFR” or “ANFR-BAS” as the code stem.'
				)
				return
			}

			let cfitems = []
			let cfassociations = []
			let hcs = ''
			let full_statement = ''
			let hcs_prefix_re = new RegExp('^(' + this.hcs_prefix + '\\S*)[.:]?(\\s|$)\\s*(.*)')
			let algo1_hcs_suffix = 0
			let log = []
			let error_count = 0
			let last_cfitem_data = {
				level: 0
			}
			let last_cfitem
			let processing_extension = ''	// also used for note
			let last_line_was_hr = false

			lines = lines.split('\n')

			// run pre-script if we have one
			if (this.pre_script) {
				lines = await this[this.pre_script](lines, log)
				if (typeof lines == 'string') {
					this.$alert('<b>Pre-Script error:</b> ' + lines)
					return
				}
			}

			let line_number = 0
			let star_length_correction = -1
			let previous_star_length = 0
			let previous_placeholder_type = ''
			let previous_placeholder_index = 0
			///////////////////////////////////////
			// go through each line
			for (let line of lines) {
				++line_number

				// remove comments, which must *start* with //
				line = line.replace(/^\s*\/\/.*/, '')

				// if convert_newlines_to_spaces, trim line, but leave tabs at the start
				if (this.convert_newlines_to_spaces) line = line.replace(/^ *(.*)\s*$/, '$1')
				console.log(line)
				// line = $.trim(line)

				// skip blank lines in some circumstances
				if (empty(line)) {
					// skip for algo2?
					if (this.parse_algo == 'algo2') continue
				}

				// if bullet_continues_item is true, change bullet characters to something that will parse nicely
				if (this.bullet_continues_item) {
					//  is what gets pasted in from the PDF for a bullet
					line = line.replace(/^\s*/, '/ • ')

					// let's also translate `a.` to '/ a. ' as well
					line = line.replace(/^([a-z]\.)\s+/, '/ $1 ')
				}

				///////////////////////////////////////////////////////
				// for algo1 (this is the "normal" way)...
				if (this.parse_algo == 'algo1') {
					// format:
					// G * :41.01400 Grade 3
					// D ** Earth and Space Science
					// S *** :S3E1 Obtain, evaluate, and communicate information about the physical attributes of rocks and soils.

					// The item_type and *'s are required; the HCS is optional

					// Note: If a line following a standard starts with "NOTES:", it will be parsed as the note field for the previous standard

					// Note: we don't allow for including a grade level because the importer will inherit the grade level(s) of the parent

					let cfitem_data = {
						level: last_cfitem_data.level, // start with the last-processed level
						humanCodingScheme: '',
						extensions: {}
					}

					// look for the start of an item, the format of which depends on the delimiter
					let found_start_of_item = false
					let item_type, stars
					if (this.delimiter == 'tabs') {
						// tabs: look for any number of tabs, which indicates the level, then an item type, then another tab, then the rest of the line
						found_start_of_item = line.search(/^(\t*)([^\t]+)\t(.*)/) == 0
						if (found_start_of_item) {
							item_type = RegExp.$2
							stars = RegExp.$1.length // this represents the "level"
							line = $.trim(RegExp.$3)
						}
					} else {
						// spaces: look for start of line, then (item_type (no spaces)), then a single space, then one or more asterisks, then a single space
						// (note that you *must* have that single space after the asterisks)
						found_start_of_item = line.search(/^(\S+\s)(\*+)\s(.*)/) == 0
						if (found_start_of_item) {
							item_type = RegExp.$1
							stars = RegExp.$2.length - 1 // this represents the "level"
							line = $.trim(RegExp.$3)
						}
					}

					if (found_start_of_item) {
						item_type = $.trim(item_type)

						// set level (zero-based) based on number of stars
						cfitem_data.level = stars
						// if star_length_correction is < 0, we're on the first non-blank line
						if (star_length_correction < 0) {
							// for future lines, we will subtract star_length_correction, which we set here to the first line's star_length
							// (so if the first line is one-star [as it really should be], it will be 0, meaning no correction)
							star_length_correction = cfitem_data.level
						}
						cfitem_data.level -= star_length_correction

						if (cfitem_data.level - previous_star_length > 1)
							process_error(line_number, 'Star levels do not match: ' + line)
						previous_star_length = cfitem_data.level

						// if we got a 'DD-' value for the item_type, we should be in a derivative framework and we're copying an item from the original framework
						if (item_type.search(/DD-(.*)/) > -1) {
							let derived_hcs = RegExp.$1

							// look for an item in the original whose hcs matches derived_hcs
							let oitem
							if (this.editor_component.viewer.is_derivative) {
								oitem = this.editor_component.viewer.derivative_original_json.CFItems.find(
									x => x.humanCodingScheme == derived_hcs
								)
							}
							if (!oitem) {
								process_error(line_number, 'Couldn’t find DD human-readable code in original framework: ' + line)
								continue
							} else {
								// found the item; merge all data from the item into cfitem
								cfitem_data = $.extend(true, cfitem_data, oitem)

								// clear identifier/URI
								delete cfitem_data.identifier
								delete cfitem_data.uri

								// if the item doesn't already have a sourceItemIdentifier/URI, set it
								if (!cfitem_data.extensions?.sourceItemIdentifier) {
									cfitem_data.extensions.sourceItemIdentifier = oitem.identifier
									cfitem_data.extensions.sourceItemURI = oitem.uri
								}
								// note that we continue to process the item below, because we might get a new humanCodingScheme
							}

						// else if we got a item_type...
						} else if (!empty(item_type)) {
							// convert _ to space, so that the user can enter fully-spelled-out types with spaces, unless escaped by a backslash
							item_type = item_type.replace(/(?<!\\)_/g, ' ').replace(/\\_/g, '_')

							// TODO: make this mapping configurable?
							let item_type_mapping = {
								G: 'Grade',
								U: 'Cluster',
								P: 'Pathway',
								C: 'Course',
								D: 'Domain',
								S: 'Standard',
								E: 'Element'
							}
							if (item_type_mapping[item_type]) {
								cfitem_data.CFItemType = item_type_mapping[item_type]

								// allow for '-' meaning "no item type"; in this case item_type is empty
							} else if (item_type != '-') {
								cfitem_data.CFItemType = item_type
							}
						}

						// record that we're not currently processing an exemplar or notes for this item
						processing_extension = ''
						last_line_was_hr = false

						// we'll continue processing the line below

					// parse META lines, which allow us to store params we may use in other lines
					// these should usually be at the top of the file, though one could change meta_params in the middle of a file
					} else if (line.search(/^META-(.*?):\s*(.*)/) == 0) {
						let key = RegExp.$1
						let val = $.trim(RegExp.$2)

						// META-assoc_dest_re2: /HSG-(\w+)\.[A-Z]\.(.*)/, 'G.$1.$2'
						if (key == 'assoc_dest_re1' || key == 'assoc_dest_re2') {
							if (val.search(/\/(.*)\/, '(.*)'/) == 0) {
								let s = RegExp.$1
								let r = RegExp.$2
								this.meta_params[key] = {
									// note that we currently specify flags as 'g', not allowing for, e.g., 'i'
									search: new RegExp(s, 'g'),
									replace: r
								}
							}

						// META-assoc_framework_identifier: c6489520-d7cb-11e8-824f-0242ac160002
						// META-assoc_framework_identifier: CLEAR	// clear previous value; will use current framework as default going forward
						} else if (key == 'assoc_framework_identifier') {
							if (val == 'CLEAR') {
								this.meta_params[key] = ''
							} else if (U.is_uuid(val)) {
								// try to load the framework here; errof if not found
								let dfr = await U.load_framework_and_cfo(val)
								if (empty(dfr)) {
									process_error(line_number, 'Framework for META assoc_framework_identifier could not be found: ' + line)
									val = ''
								}
								this.meta_params[key] = val

							} else {
								process_error(line_number, 'Invalid META assoc_framework_identifier value: ' + line)
							}

						} else {
							process_error(line_number, 'Unknown META line: ' + line)
						}

						continue

					// look for NOTES: line
					} else if (line.search(/^NOTES:\s*(.*)/) == 0) {
						// if no item has been processed yet, error
						if (empty(last_cfitem)) {
							process_error(line_number, 'Found an NOTES line, but no item has been processed yet: ' + line)
							continue
						}

						// add this note line to the last cfitem
						let notes = $.trim(RegExp.$1)
						last_cfitem.notes = process_markdown(notes)
						process_info(line_number, sr('Started notes: $1', notes))

						// record that we're currently processing notes for this item
						processing_extension = 'notes'
						continue

					// look for EXT-XXX: YYY -- extension field
					} else if (line.search(/^EXT-(.*?):\s*(.*)/) == 0) {
						// if no item has been processed yet, error
						if (empty(last_cfitem)) {
							process_error(line_number, 'Found an EXEMPLAR line, but no item has been processed yet: ' + line)
							continue
						}

						let field = RegExp.$1
						let val = RegExp.$2

						// sub for newlines
						val = val.replace(/\\n/g, '\n')

						// TODO: if field matches one the pre-defined extension fields for this Satchel instance / this item's item type, do type checking/type coersion
						// for now we'll just save as a string
						last_cfitem.extensions[field] = val

						processing_extension = field
						continue

					// look for ASSOC-xxx: line
					} else if (line.search(/^ASSOC-(.*?):\s*(.*)/) == 0) {
						let associationType = RegExp.$1
						let dest = $.trim(RegExp.$2)

						// Split destination for optional association extensions separated with '|'
						let assoc_extensions = null
						let ext_payload = null

						let parts = dest.split(/\s*\|\s*/, 2)   // split on first '|'
						dest = $.trim(parts[0])

						if (parts.length === 2) {
							ext_payload = $.trim(parts[1])
						}

						// Parse optional EXT payload into assoc_extensions.
						// Format of ASSOC-xxx: xxx | EXT: isPrimary=true; description=Addressed
						// Any parse errors are logged, but we still import the association (omitting invalid fields).
						if(!empty(ext_payload)) {
							let m = ext_payload.match(/^EXT:\s*(.*)$/i)

							if(m) {
								let parsed = this.parse_assoc_extensions(m[1])
								assoc_extensions = parsed.extensions
								
								console.log('[ASSOC EXT]', {
									line_number,
									ext_payload,
									parsed_extensions: assoc_extensions,
									parse_errors: parsed.errors
								})

								if(parsed.errors && parsed.errors.length > 0) {
									parsed.errors.forEach(e => process_error(line_number, `ASSOC EXT error: ${e} (line: ${line})`))
								}
							} else {
								process_error(line_number, `ASSOC EXT error: Expected 'EXT:' after '|'. (line: ${line})`)
							}
						}

						// origin is this item, in this framework
						// for destination, the framework may be specified by a META line; or use this framework by default
						let dest_fid = this.meta_params.assoc_framework_identifier
						if (empty(dest_fid)) dest_fid = this.editor_component.framework_record.lsdoc_identifier
						// or a guid may be provided in the line
						if (dest.search(/([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})--(.*)/) == 0) {
							dest_fid = RegExp.$1
							dest = RegExp.$2
						}

						// find the dest framework, loading if necessary
						let dfr = this.$store.state.framework_records.find(x=>x.lsdoc_identifier == dest_fid)
						// let dfr = await U.load_framework_and_cfo(dest_fid)
						if (empty(dfr)) {
							process_error(line_number, 'Couldn’t identify destination framework for ASSOCIATION: ' + line)
							continue
						}						

						if (empty(dfr.json.CFItems) || dfr.json.CFItems.length == 0) {
							process_error(line_number, 'Couldn’t get destination framework CFItems for ASSOCIATION: ' + line)
							continue
						}

						// the dest item can be explicitly specified by guid, or by human coding scheme
						let dest_item
						if (U.is_uuid(dest)) {
							dest_item = dfr.json.CFItems.find(x=>x.identifier == dest)

						} else {
							// allow for regexps on human coding schemes
							let hcs = dest
							if (!empty(this.meta_params.assoc_dest_re1)) {
								hcs = hcs.replace(this.meta_params.assoc_dest_re1.search, this.meta_params.assoc_dest_re1.replace)
							}
							dest_item = dfr.json.CFItems.find(x=>{
								let hcs2 = x.humanCodingScheme
								if (empty(hcs2)) return false
								if (this.meta_params.assoc_dest_re2) {
									hcs2 = hcs2.replace(this.meta_params.assoc_dest_re2.search, this.meta_params.assoc_dest_re2.replace)
								}
								return hcs == hcs2
							})
						}

						if (empty(dest_item)) {
							process_error(line_number, 'Couldn’t find destination framework item for ASSOCIATION: ' + line)
							continue
						}

						// success, so first make sure we have an identifier and uri for the origin item...
						if (empty(last_cfitem.identifier)) {
							last_cfitem.identifier = U.new_uuid()
							last_cfitem.uri = U.generate_child_uri(this.editor_component.framework_record.json.CFDocument, last_cfitem.identifier, 'CFItems')
						}

						// ...then create the association
						let assoc = {
							associationType: associationType,
							originNodeURI: {
								title: U.generate_cfassociation_node_uri_title(last_cfitem, true) + sr(' (:$1:)', this.editor_component.framework_record.lsdoc_identifier),
								identifier: last_cfitem.identifier,
								uri: last_cfitem.uri,
							},
							destinationNodeURI: {
								title: `${U.generate_cfassociation_node_uri_title(dest_item, true)} (:${dest_fid}:)`,
								identifier: dest_item.identifier,
								uri: dest_item.uri,
							},
						}
						// Partial extensions are allowed; only add extensions if at least one supported key exists.
						if (assoc_extensions && Object.keys(assoc_extensions).length > 0) {
							assoc.extensions = assoc_extensions
						}

						// don't insert duplicates
						let existing = this.editor_component.framework_record.json.CFAssociations.find(x=>{
							if (!x.destinationNodeURI || !x.originNodeURI) return false
							if (x.associationType != associationType) return false
							if (x.originNodeURI.identifier != last_cfitem.identifier) return false
							if (x.destinationNodeURI.identifier != dest_item.identifier) return false
							return true
						})
						if (existing) {
							process_error(line_number, 'Duplicate ASSOC found; not processing: ' + line)
							continue
						}

						// for certain types, generate a sequenceNumber for the assoc
						if (associationType == 'linkedTo') {
							let highest_n = 0
							// start with the highest sequenceNumber for assocs this item already has
							this.editor_component.framework_record.json.CFAssociations.filter(x=>{
								// look for assocs that are of this associationType and where the origin is last_cfitem
								if (!x.destinationNodeURI || !x.originNodeURI) return false
								if (x.associationType != associationType) return false
								if (x.originNodeURI.identifier != last_cfitem.identifier) return false
								if (empty(x.sequenceNumber)) highest_n += 1
								else if (x.sequenceNumber > highest_n) highest_n = x.sequenceNumber
							})

							// look for assocs of this type we've already created here
							cfassociations.filter(x=>{
								if (x.associationType != associationType) return false
								if (x.originNodeURI.identifier != last_cfitem.identifier) return false
								if (empty(x.sequenceNumber)) highest_n += 1
								else if (x.sequenceNumber > highest_n) highest_n = x.sequenceNumber
							})

							// set sequenceNumber
							assoc.sequenceNumber = highest_n + 1
						}

						cfassociations.push(assoc)
						
						processing_extension = ''
						continue

					// look for EX(EMPLAR): line
					} else if (line.search(/^(EX(EMPLAR|AMPLE|-IMPORT)?):\s*(.*)/) == 0) {
						// if no item has been processed yet, error
						if (empty(last_cfitem)) {
							process_error(line_number, 'Found an EXEMPLAR line, but no item has been processed yet: ' + line)
							continue
						}

						// if we're already processing an exemplar, report error
						if (/^EX(EMPLAR|AMPLE|-IMPORT)?/.test(processing_extension)) {
							process_error(line_number, 'Found an EXEMPLAR line, but we’re already processing an exemplar: ' + line)
							continue
						}

						// if keyword is 'EX-IMPORT' the exemplar was exported in Satchel text format, so don't do markdown processing
						processing_extension = RegExp.$1

						// add this exemplar line to the last cfitem
						let supplementalNotes = $.trim(RegExp.$3)

						// if (processing_extension == 'EX-IMPORT') last_cfitem.supplementalNotes = supplementalNotes.replace(/\&lt;/g, '<').replace(/\&gt;/g, '>')
						if (processing_extension == 'EX-IMPORT') last_cfitem.extensions.supplementalNotes = supplementalNotes
						else last_cfitem.extensions.supplementalNotes = process_markdown(supplementalNotes)
						process_info(line_number, sr('Started exemplar: $1', supplementalNotes))
						continue

					// else unlabeled line; if we're processing an extension, add to the extension
					} else if (processing_extension) {
						// if keyword was 'EX-IMPORT' the exemplar was exported in Satchel text format, so don't do markdown processing
						if (processing_extension == 'EX-IMPORT') {
							last_cfitem.extensions.supplementalNotes += '\n' + line
							// last_cfitem.extensions.supplementalNotes += '\n' + line.replace(/\&lt;/g, '<').replace(/\&gt;/g, '>')
						
						// "normal" supplementalNotes
						} else if (/^EX(EMPLAR|AMPLE|-IMPORT)?/.test(processing_extension)) {
							// '---' means an hr
							if (line.search(/^---+/) > -1) {
								line = '\n---\n'
								last_line_was_hr = true
							} else if (last_line_was_hr) {
								// for the line following an hr, make it bold/italic, unless the line was blank, in which case we skip it
								if (empty(line)) continue

								line = sr('\n***$1***\n', line)
								last_line_was_hr = false
							}
							last_cfitem.extensions.supplementalNotes += '\n' + process_markdown(line)
						
						// notes
						} else if (processing_extension == 'notes') {
							last_cfitem.notes += '\n' + process_markdown(line)

						// other extension
						} else {
							// PW 2/3/2026: note that for now we are adding two new lines between these, to ensure we get a "real" line break in these situations; if we end up with *more* than two lines, it will be condensed by the remove_line_breaks_from_text_field below.
							// we might need to have a setting for whether or not to do this, though
							last_cfitem.extensions[processing_extension] += '\n\n' + line
						}

						process_info(line_number, `Added line to ${processing_extension}: ${line}`)
						continue

					// else add to the last fullStatement
					} else {
						if (!last_cfitem) {
							if (!empty(line)) process_error(line_number, 'Unparsed line: ' + line)
						} else {
							last_cfitem.fullStatement += '\n' + process_markdown(line)
						}
						continue
					}

					// if we get to here, continue processing an item definition line

					// look for educationLevel at the start of the rest of the line
					if (line.search(/^\[(.*?)\](.*)/) == 0) {
						let gld = RegExp.$1
						line = $.trim(RegExp.$2)
						cfitem_data.educationLevel = U.grade_level_display_to_educationLevel(gld)
					}

					// look for identifier at the start of the rest of the line
					if (line.search(/^\{(.*?)\}(.*)/) == 0) {
						cfitem_data.identifier = RegExp.$1
						line = $.trim(RegExp.$2)

						// if we're only processing existing items
						if (this.no_hierarchy) {
							// when using HRCs for hierarchy mathcing, don't fail early based on identifier
							if (!this.use_hcs_for_hierarchy) {
								if (!this.editor_component.framework_record.cfo.cfitems[cfitem_data.identifier]) {
									process_error(
										line_number,
										sr(
											'Item with identifier <b>$1</b> not already in framework; this item will be skipped',
											cfitem_data.identifier
										)
									)
									// but note that we don't disrupt processing here; we'll take the item out of cfitems below
								}
							}
							// if the identifier string starts with "SID" it means we want to make a sourceItemIdentifier copy of the specified item
						} else if (cfitem_data.identifier.search(/^SID-(.*)/) > -1) {
							cfitem_data.identifier = RegExp.$1
							let oitem = this.editor_component.framework_record.json.CFItems.find(
								x => x.identifier == cfitem_data.identifier
							)
							if (!oitem) {
								process_error(
									line_number,
									sr(
										'sourceItemIdentifier copy of item with identifier <b>$1</b> requested, but couldn’t find an item with this identifier',
										cfitem_data.identifier
									)
								)
							} else {
								console.log(oitem)
								// start with the original item data
								cfitem_data = $.extend(true, cfitem_data, oitem)
								// make sure the we inherit the item type of the original (the item type might have been set to something different in cfitem_data)
								cfitem_data.CFItemType = oitem.CFItemType

								// clear identifier/URI
								delete cfitem_data.identifier
								delete cfitem_data.uri

								// if the item doesn't already have a sourceItemIdentifier/URI, set it
								if (empty(cfitem_data.extensions)) cfitem_data.extensions = {}
								if (!cfitem_data.extensions.sourceItemIdentifier) {
									cfitem_data.extensions.sourceItemIdentifier = oitem.identifier
									cfitem_data.extensions.sourceItemURI = oitem.uri
								}

								console.log(cfitem_data)
							}
						} else {
							// else if the item *is* already in the framework, it *might* be an error, so report it...
							if (this.editor_component.framework_record.cfo.cfitems[cfitem_data.identifier]) {
								process_error(
									line_number,
									sr(
										'Item with identifier <b>$1</b> already exists (this may or may not be an error…)',
										cfitem_data.identifier
									)
								)
							}
						}
					}

					// look for HCS at the start of the rest of the line
					if (line.search(/^\:(\S+)\s*(.*)/) == 0) {
						let hcs = RegExp.$1
						line = RegExp.$2

						// strip ':' off the end of the HCS if there
						hcs = hcs.replace(/:$/, '')

						// replace '_'’s with spaces in the HCS
						// allow escaped underscores (\_) to remain as literal underscores, unless escaped with a backslash (\\_)
						hcs = hcs.replace(/(?<!\\)_/g, ' ').replace(/\\_/g, '_')

						// if HCS ends with one of these, replace as follows
						if (hcs.search(/(.*\.)(xxxxx|XXXXX|#####|iiiii)$/) == 0) {
							hcs = RegExp.$1
							let placeholder_type = RegExp.$2
							if (placeholder_type != previous_placeholder_type) previous_placeholder_index = 0
							
							if (placeholder_type == 'xxxxx') hcs += 'abcdefghijklmnopqrstuvwxyz'[previous_placeholder_index]
							else if (placeholder_type == 'XXXXX') hcs += 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'[previous_placeholder_index]
							else if (placeholder_type == '#####') hcs += [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20][previous_placeholder_index]
							else if (placeholder_type == 'iiiii') hcs += ['i','ii','iii','iv','v','vi','vii','viii','ix','x','xi','xii','xiii','xiv','xv','xvi','xvii','xviii','xix','xx'][previous_placeholder_index]

							previous_placeholder_type = placeholder_type
							++previous_placeholder_index

						} else {
							// reset when we get an hcs that doesn't have a placeholder
							previous_placeholder_type = ''
							previous_placeholder_index = 0
						}

						cfitem_data.humanCodingScheme = hcs

					} else {
						// also reset these when we get an item that doesn't have an hcs
						previous_placeholder_type = ''
						previous_placeholder_index = 0
					}

					// whatever's left of the line is the fullStatement -- but not if we're processing a sourceItemIdentifier copy
					if (!cfitem_data.extensions.sourceItemIdentifier) {
						cfitem_data.fullStatement = line
					}

					// note last_cfitem in case we get a note on the next line
					last_cfitem = process_cfitem(line_number, cfitem_data)

					// record last_cfitem_data for use in parsing next item
					last_cfitem_data = cfitem_data

					// hcs = ''	// make sure this is empty for next pass through the loop, and when the loop finishes
					continue
				}
				// END OF ALGO1
				///////////////////////////////////////////////////////

				///////////////////////////////////////////////////////
				// ALGO2 (rarely used)
				// if hcs_prefix_number_separator is set,
				if (this.hcs_prefix_number_separator) {
					// then if the line starts with a number and hcs is currently empty,
					if (hcs == '' && line.search(/^\d+/) == 0) {
						// add the hcs_prefix + the separator to the start of the line
						line = this.hcs_prefix + this.hcs_prefix_number_separator + line
						// this transforms, e.g., `2.1 Standard text` to `ML.2.1 Standard text`, so that the code below will recognize this line as the start of a standard
					}
				}

				/////////////////////////////////////////////////////////////////////
				// if we find a valid human coding scheme at the start of the line...
				if (line.search(hcs_prefix_re) == 0) {
					let r1 = RegExp.$1
					let r2 = $.trim(RegExp.$3)

					// for single line mode...
					if (this.statement_options == 'single_line') {
						// if we have an hcs we're already processing, there must be an error
						if (!empty(hcs)) {
							process_error(line_number, sr('Couldn’t find a statement for the previous code ($1)', hcs))
						}

						// if this line included the full_statement,
						if (!empty(r2)) {
							// if we're in read_to_period mode,
							if (this.read_to_period) {
								// if the line ends in a period or $, process the statement right away;
								if (r2.search(/(\.|\$)$/) != -1) {
									// if line ends in $, remove the dollar sign first
									if (RegExp.$1 == '$') r2 = r2.replace(/\$$/, '')

									process_cfitem(line_number, r1, r2)

									// else register the full_statement and wait for more lines below
								} else {
									hcs = r1
									full_statement = r2
									process_info(
										line_number,
										sr(
											'Found competency code: $1; started processing statement <span style="color:#999">[$2]</span>',
											hcs,
											full_statement
										)
									)
								}

								// else not in read_to_period mode, so process the statement right away
							} else {
								process_cfitem(line_number, r1, r2)
							}

							// else set hcs
						} else {
							hcs = r1
							full_statement = ''
							process_info(line_number, sr('Found competency code: $1', hcs))
						}

						// else multiple line mode...
					} else {
						// if we have a full_statement to go with the previous hcs, process it; else error
						if (!empty(full_statement)) {
							process_cfitem('-', hcs, full_statement)
						} else {
							process_error('-', sr('Couldn’t find a statement for the previous code ($1)', hcs))
						}

						// set hcs and set full_statement to whatever was after the hcs (if anything)
						hcs = r1
						full_statement = r2
						process_info(line_number, sr('Found competency code: $1', hcs))
					}

					/////////////////////////////////////////////////
					// else it's a line that didn't start with an hcs
				} else {
					// if we're in 'single_line' mode...
					if (this.statement_options == 'single_line') {
						// if we have an hcs we're currently processing
						if (!empty(hcs)) {
							// if we're in "read_to_period" mode, we must be waiting for text to accompany the hcs
							if (this.read_to_period) {
								if (!empty(full_statement)) full_statement += ' '
								full_statement += line

								// if the full_statement ends in a period now, process this competency
								if (full_statement.search(/(\.|\$)$/) != -1) {
									// if line ends in $, remove the dollar sign first
									if (RegExp.$1 == '$') full_statement = full_statement.replace(/\$$/, '')

									process_cfitem(line_number, hcs, full_statement)
									// then clear hcs and full_statement
									hcs = ''
									full_statement = ''
								}

								// else not read_to_period mode
							} else {
								// if full_statement is currently empty, this line is the full_statement for the hcs; process it
								if (empty(full_statement)) {
									process_cfitem(line_number, hcs, line)
									// then clear hcs (full_statement is already clear)
									hcs = ''

									// else we have an hcs and a full statement already; this shouldn't happen but account for it just in case
								} else {
									process_error(line_number, 'Code and statement already exist...')
								}
							}

							// else we don't have an hcs we're currently processing and we're in single line mode, so skip the line (no error)
						} else {
							process_info(line_number, sr('Skipping line <span style="color:#999">[$1]</span>', line))
						}

						// else we're in 'multiple_line' mode
					} else {
						// if we have an hcs we're currently process, add to full_statement
						if (!empty(hcs)) {
							// we could add an option whether or not to separate lines with line breaks; for now we'll collapse them
							if (!empty(full_statement)) full_statement += ' '
							full_statement += line
							// we don't have to log this line, because it'll be logged when the competency finishes processing

							// else we're not currently processing an hcs, so skip the line
						} else {
							process_info(line_number, sr('Skipping line <span style="color:#999">[$1]</span>', line))
						}
					}
				}
				// END OF ALGO2 (rarely used)
				///////////////////////////////////////////////////////
			}
			// finished going through each line
			///////////////////////////////////////

			// if we have an un-processed hcs...
			if (!empty(hcs)) {
				// then if we're in single_line mode, it's an error
				if (this.statement_options == 'single_line') {
					process_error('-', sr('Reached end of text with an unprocessed code ($1)', hcs))

					// else we're in multiple_line mode...
				} else {
					// if we have a full_statement to go with the hcs, process it; else it's an error
					if (!empty(full_statement)) {
						process_cfitem('-', hcs, full_statement)
					} else {
						process_error('-', sr('Reached end of text with an unprocessed code ($1)', hcs))
					}
				}
			}

			// easy natural sort algorithm that actually seems to work!
			// https://fuzzytolerance.info/blog/2019/07/19/The-better-way-to-do-natural-sort-in-JavaScript/
			if (this.parse_algo == 'algo2') {
				cfitems.sort((a, b) =>
					a.humanCodingScheme.localeCompare(b.humanCodingScheme, navigator.languages[0] || navigator.language, {
						numeric: true,
						ignorePunctuation: true
					})
				)
			}

			// for algo2, if this.create_trees is true, put children under parents -- up to three levels
			// also add CFItemType from item_type array
			if (this.create_trees && this.parse_algo == 'algo2') {
				let current_parent_1 = ''
				let current_parent_2 = ''
				for (let cfitem of cfitems) {
					let hcs = cfitem.humanCodingScheme
					if (current_parent_2 && hcs.indexOf(current_parent_2) == 0) {
						// e.g. cp2 = AFNR-BAS-1.1 and hcs = AFNR-BAS-1.1a
						cfitem.level = 2
					} else if (current_parent_1 && hcs.indexOf(current_parent_1) == 0) {
						// e.g. cp1 = AFNR-BAS-1 and hcs = AFNR-BAS-1.1
						cfitem.level = 1
						current_parent_2 = hcs
						if (this.algo2_item_types.length > 1) cfitem.CFItemType = this.algo2_item_types[0]
						else if (this.algo2_item_types.length > 0) cfitem.CFItemType = this.algo2_item_types[0]
					} else {
						// e.g. hcs = ANFR-BAS-1 or ANFR-BAS-2
						cfitem.level = 0
						current_parent_1 = hcs
						current_parent_2 = ''
					}
					// note that this algorithm would mistakenly put ANFR-BAS-10 a level under ANFR-BAS-1 if they come right after each other, but that shouldn't happen

					// if we have algo2_item_types
					if (this.algo2_item_types.length > 0) {
						// add item_type for this level, or last item_type as default
						if (this.algo2_item_types.length >= cfitem.level) {
							cfitem.CFItemType = this.algo2_item_types[cfitem.level]
						} else {
							cfitem.CFItemType = this.algo2_item_types[this.algo2_item_types.length - 1]
						}
					}
				}
			}

			// final array...
			let final_arr = []
			let updated_word = ''
			for (let cfitem of cfitems) {
				// use remove_line_breaks_from_text_field on notes, fullStatements, abbreviatedStatements, and extensions except supplementalNotes, if convert_newlines_to_spaces is on
				if (this.convert_newlines_to_spaces) {
					if (cfitem.fullStatement) cfitem.fullStatement = U.remove_line_breaks_from_text_field(cfitem.fullStatement)
					if (cfitem.abbreviatedStatement)
						cfitem.abbreviatedStatement = U.remove_line_breaks_from_text_field(cfitem.abbreviatedStatement)
					if (cfitem.notes) cfitem.notes = U.remove_line_breaks_from_text_field(cfitem.notes)
					for (let key in cfitem.extensions) {
						if (key != 'supplementalNotes') {
							cfitem.extensions[key] = U.remove_line_breaks_from_text_field(cfitem.extensions[key])
						}
					}
				}

				// Grab the fullStatement for error logging HRC update
				let import_stmt_for_log = $.trim(((cfitem.fullStatement || '') + '').replace(/\s+/g, ' '))

				// if we didn't get a fullStatement, delete it, so that we don't overwrite it in when we save if we're updating existing items.
				if (empty(cfitem.fullStatement)) delete cfitem.fullStatement
				
				// just trim supplementalNotes, since they may have html
				if (cfitem.extensions.supplementalNotes)
					cfitem.extensions.supplementalNotes = $.trim(cfitem.extensions.supplementalNotes)

				// convert exemplar from markdown to html
				// console.log(cfitem.extensions.supplementalNotes)
				if (cfitem.extensions.supplementalNotes) {
					cfitem.extensions.supplementalNotes = marked(cfitem.extensions.supplementalNotes).replace(/\s*\n\s*/g, ' ')
				}
				// console.log(cfitem.extensions.supplementalNotes)

				// if we're processing items only...
				if (this.no_hierarchy) {
					updated_word = '<b>updated</b>'
					// then if the item *isn't* already in the framework, don't process it (note that we reported an error about the item above)
					// NOTE (update-only + use_hcs_for_hierarchy):
					// We match existing items by humanCodingScheme (HCS/HRC).
					// - If exactly one item matches that HCS, we update it.
					// - If multiple items share the same HCS, we require an EXACT fullStatement match to select which item to update.
					//   This means fullStatement is used as a strict disambiguator (exact match after normalization).
					//   If the incoming statement has been edited and no longer matches exactly, we treat it as ambiguous and skip with an error
					//   to avoid updating the wrong item. This is added for CPS frameworks that could be changing a lot of EXT- fields only. 
					let old_item
					
					if (this.use_hcs_for_hierarchy) {
						let hcs = cfitem.humanCodingScheme
						
						if (empty(hcs)) {
							process_error('-', sr('Item does not have a HRC for <span style="color:#999">[$1]</span>. This item will be skipped and not updated. (Safe to process)', import_stmt_for_log || '(no statement)'))
							continue
						}
						
						let candidates = (this.editor_component.framework_record.json.CFItems || []).filter(x => x && x.humanCodingScheme == hcs)
							
						if (candidates.length == 0) {
							process_error('-', sr('Item with HCS <b>$1</b> not already in framework; this item will be skipped and not updated (Safe to process)', hcs))
							continue
						}
						
						let pick = null
						
						if (candidates.length == 1) {
							pick = candidates[0]
						} else {
 
							let normalize_stmt = s => $.trim((s || '').replace(/\s+/g, ' '))
							let incoming_stmt = normalize_stmt(cfitem.fullStatement)
							
							if (empty(incoming_stmt)) {
								process_error('-', sr('Multiple items found with HRC: <b>$1</b> and no fullStatement present. Please update this item manually or by using {identifier} batch import. You can safely click UPDATE, but this item will be skipped and not updated', hcs))
								continue
							}
							
							let stmt_matches = candidates.filter(x => normalize_stmt(x.fullStatement) == incoming_stmt)
							
							if (stmt_matches.length == 1) {
								
								pick = stmt_matches[0]
							} else {
								process_error('-', sr('Multiple items found with HRC: <b>$1</b> and the fullStatement has changed. Please update this item manually or by using {identifier} batch import. You can safely click UPDATE, but this item will be skipped.', hcs))
								continue
							}
						}

						// Prefer pulling the object from cfo.cfitems by identifier
						old_item = this.editor_component.framework_record.cfo.cfitems[pick.identifier] || pick

						// Ensure the incoming item has identifier/uri so behavior is consistent
						cfitem.identifier = pick.identifier
						if (pick.uri && empty(cfitem.uri)) cfitem.uri = pick.uri
					} else {
						// set old_item to match by identifier
						old_item = this.editor_component.framework_record.cfo.cfitems[cfitem.identifier]
					}

					if (!old_item) {
						continue
					} else {
						// else only process it if the item changed
						let before = JSON.stringify(new window.CFItem(old_item).to_json())
						let after = JSON.stringify(new window.CFItem(cfitem).to_json())
						// if anything changed, update lastChangeDateTime and add to final_arr
						if (before != after) {
							cfitem.lastChangeDateTime = '*NOW*'
							console.log('before copy: ' + before)
							console.log('afterx copy: ' + after)
						} else {
							// else skip the item
							console.log('skipping unchanged:' + before)
							continue
						}
						// NR: check to make sure that only properties in the satchelscript are being update or added; any other properties in the existing item should remain intact
					}
				}
				final_arr.push(cfitem)
			}
			cfitems = final_arr

			// if the number of items in the current famework would exceed X, give a special warning
			let updated_n_items = this.editor_component.framework_record.json.CFItems.length + cfitems.length
			if (updated_n_items > this.recommended_max_cfitems) {
				let title = 'Warning'
				let text = `This import will add ${cfitems.length} items to this framework, which will make the total count of items in the framework <b>${updated_n_items}</b>.`
					+ `<div class="mt-3">Frameworks with more than ${this.recommended_max_cfitems} items become difficult to manage, so we recommend that you create a new framework at this point rather than import these items to this framework.</div>`
					+ `<div class="mt-3">Click “PROCEED WITH IMPORT” to ignore this warning and proceed.</div>`
				let confirmed = await U.confirm_promise({
					title,
					text,
					acceptText: 'PROCEED WITH IMPORT',
					dialogMaxWidth: 600,
				})

				// if user clicks cancel, bail out
				if (!confirmed) return

				// user clicked OK, so continue processing
			}

			// show log and give user options for what to do
			let error_text = ''
			if (error_count > 0)
				error_text = sr(
					'; <span class="red white--text" style="padding:3px 6px; border-radius:4px;">$1 possible $2</span>',
					error_count,
					U.ps('error', error_count)
				)
			let text = sr(
				'<div style="margin-top:-10px; margin-bottom:8px;">Processed $1 lines; found $2 $3 competencies$4.</div>',
				line_number,
				cfitems.length,
				updated_word,
				error_text
			)

			text += '<div class="mb-1">Competencies:</div>'
			text += '<div style="margin-left:16px; font-size:14px; line-height:18px;">'
			for (let cfitem of cfitems) {
				let margin = 25 * (cfitem.level + 1) + 'px'
				let item_type = !empty(cfitem.CFItemType) ? sr(' <i>[$1]</i> ', cfitem.CFItemType) : ''
				let ed_level =
					!empty(cfitem.educationLevel) && cfitem.educationLevel.length > 0
						? sr(' [$1] ', U.grade_level_display(cfitem.educationLevel))
						: ''
				let identifier = !empty(cfitem.identifier) ? sr(' {$1} ', cfitem.identifier) : ''
				let hcs = !empty(cfitem.humanCodingScheme) ? sr('<b>$1:</b> ', cfitem.humanCodingScheme) : ''
				let notes = !empty(cfitem.notes) ? sr(' <b>NOTES:</b> $1', cfitem.notes.replace(/\n/g, ' / ')) : ''
				// note that supplemental info is now included in extensions
				let extensions = (!empty(cfitem.extensions) && Object.keys(cfitem.extensions).length > 0)
					? `<br><b>EXTENSIONS:</b><pre style="font-family:monospace;font-size:12px;text-indent:0;">${JSON.stringify(cfitem.extensions, null, 4).replace(/</g, '&lt;')}</pre>`
					: ''
				
				// add imported assocs
				let associations = ''
				for (let assoc of cfassociations) {
					if (assoc.originNodeURI.identifier == cfitem.identifier) {
						associations += `<br><b>ASSOC:</b> ${assoc.associationType}${assoc.sequenceNumber ? ' ('+assoc.sequenceNumber+')' : ''} -- ${assoc.destinationNodeURI.title}`
					}
				}

				text += sr(
					'<div style="margin-left:$1; text-indent:-35px; margin-top:4px;">• $2$3$4$5$6$7$8$9</div>',
					margin,
					hcs,
					ed_level,
					identifier,
					cfitem.fullStatement ?? '',
					item_type,
					notes,
					extensions,
					associations
				)
			}
			text += '</div>'

			text += '<div class="mt-4 mb-2"><b>Processing log:</b></div>'
			text += '<div class="k-case-item-importer-report"><div class="k-case-item-importer-report-inner">'
			for (let log_line of log) text += sr('<div style="margin-left:50px; text-indent:-50px;">$1</div>', log_line)
			text += '</div></div>'

			let acceptText = this.no_hierarchy
				? sr('Update $1 $2', cfitems.length, U.ps('Item', cfitems.length))
				: sr('Add $1 Child $2', cfitems.length, U.ps('Item', cfitems.length))
			this.$confirm({
				title: 'Processing Results',
				text: text,
				acceptText: acceptText,
				dialogMaxWidth: 950
			})
				.then(y => {
					this.complete_save(cfitems, cfassociations)
				})
				.catch(n => {
					console.log(n)
				})
				.finally(f => {})

			console.log(cfitems, cfassociations)
		},

		parse_assoc_extensions(ext_body) {
			// Partial extensions are allowed
			// add whichever supported values exist, omit the invalid ones
			// if there is an unknown key processed, omit and log an error

			let extensions = {}
			let errors = []

			if (!ext_body || !String(ext_body).trim()) return { extensions, errors }

			// split on ';' between key/value pairs
			let pairs = String(ext_body).split(/\s*;\s*/).filter(p => p.length > 0)

			for (let pair of pairs) {
				let eq = pair.indexOf('=')
				if (eq < 0) {
					errors.push(`Bad EXT pair (missing '='): ${pair}`)
					continue
				}

				let key = pair.slice(0, eq).trim()
				let val = pair.slice(eq + 1).trim()

				if (key === 'isPrimary') {
					if (/^(true|false)$/i.test(val)) {
						extensions.isPrimary = (val.toLowerCase() === 'true')
					} else {
						// invalid boolean = error, and omit isPrimary
						errors.push(`Invalid EXT isPrimary value (must be true/false): ${val}`)
					}
				} else if (key === 'description') {
					// support both '...' and "..."
					if ((val.startsWith('"') && val.endsWith('"')) || (val.startsWith("'") && val.endsWith("'"))) {
						val = val.slice(1, -1)
					}
					extensions.description = val
				} else {
					errors.push(`Unknown EXT key ignored: ${key}`)
				}
			}
			
			return { extensions, errors }
		},

		complete_save(cfitems_data, cfassociations_data) {
			console.warn('complete_save', cfassociations_data)
			// get some things from the editor
			let CFItem, original_node
			if (this.editor_component.editor_type == 'document') {
				original_node = this.editor_component.cftree
			} else {
				original_node = this.editor_component.original_node
				CFItem = this.editor_component.CFItem
			}
			let CFDocument = this.editor_component.CFDocument
			let framework_record = this.editor_component.framework_record
			let cfo = framework_record.cfo
			let lsdoc_identifier = framework_record.lsdoc_identifier

			let data = {
				update_item_types: true, // this will trigger the save_framework_data dispatch fn to deal with CFItemTypes
				lsdoc_identifier: lsdoc_identifier,
				CFItems: [],
				CFAssociations: []
			}

			let parent_node = [original_node, null, null]
			this.editor_component.viewer.new_imported_item_identifiers = []

			for (let cfitem_data of cfitems_data) {
				// if no_hierarchy is true, we *skip* any items that don't already exist
				if (this.no_hierarchy) {
					if (!cfo.cfitems[cfitem_data.identifier]) {
						console.log('skipping item cfitem_data.identifier')
						continue
					}
				}

				//////// first follow the pattern of what we do when adding a new sibling or child item (add_sibling)

				let new_CFItem
				if (this.no_hierarchy) {
					// if we're updating existing items, we don't want to use the CFItem constructor, because it may add empty values or default values for fields we don't want to update
					new_CFItem = object_copy(cfitem_data)
					// delete the `level` property that we inserted above
					delete new_CFItem.level

				} else {
					// if we're not updating existing items, merge with data from the current CFItem for empty fields (if we don't have CFItem, we're adding top-level items to the document)
					if (CFItem) {
						// only do this for language and educationLevel for now
						if (!cfitem_data.language && CFItem.language) cfitem_data.language = CFItem.language
						if (!cfitem_data.educationLevel && CFItem.educationLevel)
							cfitem_data.educationLevel = CFItem.educationLevel // .concat([])
						// if (!cfitem_data.alternativeLabel && CFItem.alternativeLabel) cfitem_data.alternativeLabel = CFItem.alternativeLabel
						// if (!cfitem_data.CFItemType && CFItem.CFItemType) cfitem_data.CFItemType = CFItem.CFItemType
						// if (!cfitem_data.CFItemTypeURI && CFItem.CFItemTypeURI) cfitem_data.CFItemTypeURI = CFItem.CFItemTypeURI
						// if (!cfitem_data.conceptKeywords && CFItem.conceptKeywords) cfitem_data.conceptKeywords = CFItem.conceptKeywords
						// if (!cfitem_data.conceptKeywordsURI && CFItem.conceptKeywordsURI) cfitem_data.conceptKeywordsURI = CFItem.conceptKeywordsURI
						// if (!cfitem_data.licenseURI && CFItem.licenseURI) cfitem_data.licenseURI = CFItem.licenseURI
					} else {
						// if we don't have CFItem, we're adding top-level items to the document; the only thing we get from the document is the language
						if (!cfitem_data.language && CFDocument.language) cfitem_data.language = CFDocument.language
					}

					// use the CFItem constructor, with complete_data and to_json, to get a new identifier, uri, etc. (we might have actually generated the identifier and uri above, but if so complete_data will just skip doing this)
					new_CFItem = new window.CFItem(cfitem_data)
					new_CFItem.complete_data(CFDocument) // note that this sets lastChangeDateTime to *NOW*; if no_hierarchy mode is on, we only change dates for updated items, above
				}

				// console.log(cfitem_data.level, new_CFItem.to_json())

				// see if the item is already a child of the parent_node...
				let child_node, sequenceNumber, node_was_added
				if (!this.no_hierarchy) {
					if (cfo.cfitems[cfitem_data.identifier]) {
						child_node = parent_node[cfitem_data.level].children.find(
							x => x.cfitem.identifier == cfitem_data.identifier
						)
					}

					// if it's not already a child of the parent_node, add it to the cfo (if it is already a child, we're just updating the item)
					if (!child_node) {
						// determine the sequenceNumber for the new item -- have to do this before we add the node
						sequenceNumber = U.get_next_sequenceNumber(parent_node[cfitem_data.level], framework_record)
						// console.log('new item sequenceNumber: ' + sequenceNumber)

						// add to cfo
						child_node = U.add_child_to_cfo(new_CFItem.to_json(), parent_node[cfitem_data.level], this.$store, cfo)

						node_was_added = true
					} else {
						console.log('NODE ALREADY EXISTED: ' + cfitem_data.fullStatement.substr(0, 20))
					}

					// this item will be the parent node for subsequent items at the next level
					parent_node[cfitem_data.level + 1] = child_node
				}

				////////// then follow the pattern for what we do in save_changes

				// if we're not just updating existing items, use the CFItem.to_json fn to get clean json (if we are updating existing items, we won't have converted to a CFItem object)
				if (!this.no_hierarchy) new_CFItem = new_CFItem.to_json()

				// push json for CFItems; it was already created in add_child_to_cfo
				data.CFItems.push(new_CFItem)
				this.editor_component.viewer.new_imported_item_identifiers.push(new_CFItem.identifier)

				// if node_was_added, create an 'isChildOf' association for the item, and add to data
				if (node_was_added) {
					let child_association = U.create_association(
						parent_node[cfitem_data.level].cfitem,
						new_CFItem,
						sequenceNumber,
						CFDocument
					)
					data.CFAssociations.push(child_association.to_json())
				}
			}

			// for each to-be-processed cfassociation_data...
			for (let cfassociation_data of cfassociations_data) {
				let new_CFAssociation = new window.CFAssociation(cfassociation_data)
				new_CFAssociation.complete_data(CFDocument)
				data.CFAssociations.push(new_CFAssociation.to_json())
			}

			// make sure max-editor is closed
			this.ta_dialog_open = false

			// if we have a post_script, call it
			if (this.post_script) {
				this[this.post_script](data)
			}

			console.log(data)

			// Show import confirm and wait for user to save
			this.editor_component.viewer.show_import_confirm = true
			this.editor_component.viewer.import_data = data // note that we *don't* want viewer.import_data to be reactive
			this.editor_component.cancel_edit()

			// call save_imported_items in editor_component.viewer
			// this.editor_component.viewer.save_imported_items(data)

			if (this.no_hierarchy) {
				this.$alert('Note that after saving, you must update your browser window to see updates to existing items.')
			}
		},

		show_resource_ai_import_interface() {
			this.resource_ai_import_interface_showing = true
		},

		////////////////////////////////////////
		// pre scripts: these can run before the import script runs
		pre_script_sc_course_code_import(lines) {
			let arr = []
			let last_subject = '',
				last_grades = ''
			let grade_mappings = {
				'1Grades PreK-6': ['PK-06', 'Grades PreK–6'],
				'2Grades 7th-8th': ['07-08', 'Grades 7–8'],
				'3Grades 9th-12th': ['09-12', 'Grades 9–12'],
				'All Grade Levels': ['PK-12', 'All Grade Levels']
			}
			for (let line of lines) {
				// each line should include these values:
				let [subject_code, subject_text, course_code, course_text, grades, notes] = line.split('\t')

				// extract educationLevel from the grades value
				let [educationLevel, grade_string] = grade_mappings[grades]

				// When subject changes, create new *
				if (last_subject != subject_code) {
					arr.push(`Subject * [${educationLevel}] :${subject_code} ${subject_text}`)
					last_subject = subject_code
					last_grades = '' // always create a new grade when we create a new domain
				}

				// When grade changes, create new **
				if (last_grades != grades) {
					arr.push(`Grade_Span ** [${educationLevel}] ${grade_string}`)
					last_grades = grades
				}

				// every line has a course
				arr.push(`Course *** [${educationLevel}] :${course_code} ${course_text}`)

				// add notes if there
				if (!empty(notes)) {
					// notes = notes.replace(/ XX /g, '\n')
					// console.warn(notes)
					// arr.push(`NOTES:\n${notes}`)
					notes = notes.split(/ XX /)
					arr.push('NOTES:')
					for (let n of notes) {
						arr.push(n)
						arr.push('')
					}
				}
			}

			return arr
		},

		pre_script_cl_evidence_statements_import(lines) {
			let arr = []
			let last_grade = ''
			let last_domain = ''
			let last_cluster = ''
			let grade_mappings = {
				0: ['KG', 'Kindergarten'],
				1: ['01', 'Grade 1'],
				2: ['02', 'Grade 2'],
				3: ['03', 'Grade 3'],
				4: ['04', 'Grade 4'],
				5: ['05', 'Grade 5'],
				6: ['06', 'Grade 6'],
				7: ['07', 'Grade 7'],
				8: ['08', 'Grade 8'],
				A: ['09-12', 'High School: Algebra'],
				F: ['09-12', 'High School: Functions'],
				G: ['09-12', 'High School: Geometry'],
				N: ['09-12', 'High School: Number and Quantity'],
				S: ['09-12', 'High School: Statistics & Probability'],

				'00': ['KG', 'Kindergarten'],
				'01': ['01', 'Grade 1'],
				'02': ['02', 'Grade 2'],
				'03': ['03', 'Grade 3'],
				'04': ['04', 'Grade 4'],
				'05': ['05', 'Grade 5'],
				'06': ['06', 'Grade 6'],
				'07': ['07', 'Grade 7'],
				'08': ['08', 'Grade 8'],
				'9-10': ['09-10', 'Grade 9-10'],
				'11-12': ['11-12', 'Grade 11-12'],
				'K-12': ['KG-12', 'Grade K-12']
			}
			for (let line of lines) {
				// each line should include these values:
				let [grade, domain_code, domain_text, cluster_code, cluster_text, es_code, es_text, notes] = line.split('\t')

				// get educationLevel and grade_text for the grade
				let [educationLevel, grade_text] = grade_mappings[grade]

				if (!empty(domain_code)) domain_code = ':' + domain_code
				if (!empty(cluster_code)) cluster_code = ':' + cluster_code

				// When grade changes, create new *
				if (last_grade != grade) {
					arr.push(`Grade_Level * [${educationLevel}] ${grade_text}`)
					last_grade = grade
					last_domain = '' // always create a new cluster when we create a new domain
				}

				// When Domain changes, create new **
				if (last_domain != domain_text) {
					arr.push(`Domain ** [${educationLevel}] ${domain_code} ${domain_text}`)
					last_domain = domain_text
					last_cluster = '' // always create a new cluster when we create a new domain
				}

				// When Cluster changes, create new ***
				if (last_cluster != cluster_text) {
					arr.push(`Cluster *** [${educationLevel}] ${cluster_code} ${cluster_text}`)
					last_cluster = cluster_text
				}

				// every line has an evidence statment -- ****
				arr.push(`Evidence_Statement **** [${educationLevel}] :${es_code} ${es_text}`)

				// add notes if there
				if (!empty(notes)) {
					// notes = notes.replace(/ XX /g, '\n')
					// console.warn(notes)
					// arr.push(`NOTES:\n${notes}`)
					notes = notes.split(/ XX /)
					arr.push('NOTES:')
					for (let n of notes) {
						arr.push(n)
						arr.push('')
					}
				}
			}

			return arr
		},

		pre_script_edsby_course_import(lines) {
			function educationLevel_from_grades(grades) {
				let s = ''
				for (let grade of grades) {
					if (s) s += ','
					if (grade == '0K') s += 'KG'
					else if (grade < 10) s += '0' + grade
					else s += grade
				}
				return s
			}

			let line_number = 0
			// first line should be COURSES
			let line = $.trim(lines.shift())
			if (line != 'COURSES') return 'First line is not `COURSES`'
			++line_number

			line = $.trim(lines.shift())
			++line_number

			let subjects = []
			let course_hash = {}

			// read until we get to the COMPETENCIES line
			while (lines.length > 0) {
				// note that the first iteration here will skip the header line for courses
				line = $.trim(lines.shift())
				++line_number

				// skip blank lines
				if (!line) continue

				if (line == 'COMPETENCIES') break

				// SchoolID	CourseID	CourseName	ShortName	Subject	Grade	CourseType	Summary	Prerequisite	Standard	_opx	Notes
				// *	SK.0105	Arts Education 01	ART01	Arts Education	1
				let fields = line.split('\t')
				let course_id = fields[1]
				let course_name = fields[2]
				let short_name = fields[3]
				let subject_name = fields[4]
				let grade = fields[5]

				// create object for each new subject encountered, with array for courses
				let so = subjects.find(x => x.subject_name == subject_name)
				if (!so) {
					so = {
						subject_name: subject_name,
						courses: [],
						grades: []
					}
					subjects.push(so)
				}

				// create object for each course encountered, with array for competencies
				let co = so.courses.find(x => x.course_name == course_name)
				if (!co) {
					co = {
						course_id: course_id,
						course_name: course_name,
						short_name: short_name,
						// in the current sample we seem to always have one grade per course, but be prepared...
						grades: [grade],
						comps: []
					}

					so.courses.push(co)

					// also create hash for courses
					course_hash[co.course_id] = co

					// add grade to subject array
					if (!so.grades.includes(co.grade)) so.grades.push(co.grade)
				}
			}

			// if we didnt end with the COMPETENCIES line, that's an error
			if (line != 'COMPETENCIES') return 'Competencies not found'
			lines.shift() // skip header line
			++line_number

			while (lines.length > 0) {
				line = $.trim(lines.shift())
				++line_number
				// skip blank lines
				if (!line) continue

				// add each competency to its course

				// SchoolID	REGION	CourseID	ItemType	Name	Body
				// *	SK	SK.0010	Document.LearningStandard	ID	Intellectual Domain: Intellectual Development Involves: Knowledge and concepts; Creativity and representation; Communication skills; Emerging literacy; Problem solving abilities; Numeracy exploration.
				// *	SK	SK.0010	Document.LearningStandard	ID.ELAK1	I can apply what I know to texts by making predictions, asking and responding to questions, and expressing my feelings.
				let fields = line.split('\t')

				let item_type = fields[3]
				if (item_type == 'Document.LearningStandard') item_type = 'Learning_Standard'
				else if (typeof item_type != 'string') {
					return `item_type not found (line ${line_number}): ${line}`
				} else item_type = item_type.replace(/(\s|\.)/g, '_')

				let comp = {
					course_id: fields[2],
					item_type: item_type,
					hcs: fields[4],
					statement: fields[5]
				}
				let course = course_hash[comp.course_id]
				if (!course) return 'course_id not found in competency listing: line ' + line_number

				course.comps.push(comp)
			}

			console.log(subjects)

			// now go through and create items for each subject, course, and competency
			// S *** :S3E1 Obtain, evaluate, and communicate information...
			let arr = []
			for (let subject of subjects) {
				arr.push(`Subject * ${subject.subject_name}`)

				for (let course of subject.courses) {
					let grades = educationLevel_from_grades(course.grades.sort())
					arr.push(`Course ** [${grades}] :${course.course_id} ${course.course_name}`)

					// sort comps by hcs
					course.comps.sort((a, b) => U.natural_sort(a.hcs, b.hcs))

					let last_first_level_hcs = ''
					for (let comp of course.comps) {
						// allow for two levels of hierarchy
						let level = '***'
						// if last_hcs is 'ID' and this one is 'ID.ELAK1', bump up one star; otherwise leave at 3
						if (comp.hcs.includes('.') && last_first_level_hcs && comp.hcs.includes(last_first_level_hcs)) {
							level += '*'
						} else {
							last_first_level_hcs = comp.hcs
						}
						arr.push(`${comp.item_type} ${level} [${grades}] :${comp.hcs} ${comp.statement}`)
					}
				}
			}

			// sort comps numerically? SK.0605
			// other ones to check: SK.0900
			return arr
		},

		/**
     * E * [02-04] :8.SC.1 Evaluate movement concepts with a variety of activities, alone and with others.
     */
		pre_script_asn(lines) {
			lines = lines.join('\n')
			const json = JSON.parse(lines)
			function built_tree_from_json(data) {
				const lookup = {}

				// Step 1: Initialize lookup table with children arrays
				Object.keys(data).forEach(key => {
					lookup[key] = { ...data[key], children: [] }
				})

				// Step 2: Recursively attach children based on 'hasChild' field
				Object.keys(data).forEach(key => {
					const item = data[key]
					const node = lookup[key]
					// Attach the children if 'hasChild' exists
					if (item['http://purl.org/gem/qualifiers/hasChild']) {
						item['http://purl.org/gem/qualifiers/hasChild'].forEach(child => {
							const child_id = child.value
							if (lookup[child_id]) {
								node.children.push(lookup[child_id]) // Attach the child
							} else {
								console.warn(`Child with ID ${child_id} not found`)
							}
						})
					}
				})
				// Step 3: Find the root nodes (nodes without 'isChildOf') and return the tree
				const tree = Object.keys(data)
					.filter(key => !data[key]['http://purl.org/gem/qualifiers/isChildOf']) // Root nodes have no parents
					.map(key => lookup[key])
				return tree
			}
			const tree = built_tree_from_json(json)
			// console.log(JSON.stringify(tree, null, 2));
			// console.log(tree)
			function create_import_text(node, stars, is_document = true) {
				let result = ''
				// Skip the document item(root passed in)
				if (!is_document) {
					if (node['http://purl.org/ASN/schema/core/statementLabel']) {
						const statement_label = node['http://purl.org/ASN/schema/core/statementLabel'][0].value
						result += `${statement_label.split(' ').join('_')} `
					} else {
						result += `- `
					}
					result += '*'.repeat(stars)
					// If the current item has a description, add it to the result
					if (node['http://purl.org/dc/terms/educationLevel']) {
						const format_grade_level = value => {
							if (value === 'K') {
								return 'KG' // Convert "K" to "KG"
							}
							// If value is numeric, ensure it has two digits
							return value.padStart(2, '0')
						}
						const education_level = node['http://purl.org/dc/terms/educationLevel']
						const first_value = education_level[0].value.split('/').pop()
						const last_value = education_level[education_level.length - 1].value.split('/').pop()

						const first_grade_level = format_grade_level(first_value)
						const last_grade_level = format_grade_level(last_value)
						// console.log(first_grade_level, last_grade_level, education_level)
						result += ` [${first_grade_level}-${last_grade_level}] `
					}
					if (node['http://purl.org/ASN/schema/core/statementNotation']) {
						const human_readable_code = node['http://purl.org/ASN/schema/core/statementNotation'][0].value
						result += ` :${human_readable_code}`
					}
					if (node['http://purl.org/dc/terms/description']) {
						const description = node['http://purl.org/dc/terms/description'][0].value
						result += ` ${description}\n`
					}
				}
				if (node.children && node.children.length > 0) {
					node.children.forEach(child_node => {
						result += create_import_text(child_node, stars + 1, false) // Recursive call for children
					})
				}
				return result
			}
			const import_statement = create_import_text(tree[1], 0) // Start from the root node of the tree
			return import_statement.split('\n')
		},

		pre_script_cps_tfg_link(lines, log) {
			// This pre-script should be run when importing to an existing branch of a framework. 
			// The goal is to attach TFG and slide links to lessons in the branch
			// The operator pastes into the SatchelScript textarea the contents of a google sheet with four columns:
			// 		Lesson_Code		TFG_URL		Slides_(ENG)_URL		Slides_(SP)_URL

			// this prescript requires the following settings:
			this.no_hierarchy = true
			this.convert_newlines_to_spaces = true
			this.parse_algo = 'algo1'

			// get all descendent Lessons for the currently-selected item in the tree
			let active_node = this.editor_component.viewer.active_node
			let branch = this.editor_component.viewer.cfo.tree_nodes_hash[active_node]

			let darr = []
			let parent_fs_by_lesson_id = {}
			let get_descendents = (node) => {
				if (node.cfitem.CFItemType == 'Lesson') {
					darr.push(node.cfitem)
					parent_fs_by_lesson_id[node.cfitem.identifier] = (node.parent_node && node.parent_node.cfitem) ? node.parent_node.cfitem.fullStatement : ''
				}

				for (let child of node.children) {
					get_descendents(child)
				}
			}
			get_descendents(branch)
			
			if (darr.length == 0) {
				return ('No Lessons found in the active branch')
			}

			let output = []

			// skip header
			lines.shift()
			let line_number = 1
			for (let line of lines) {
				++line_number
				line = line.trim()
				if (empty(line)) continue

				// each line should include these values:
				let [lesson_code, tfg_link, slides_en_link, slides_sp_link] = line.split('\t')
				// console.warn(lesson_code)
				// console.warn(tfg_link)
				// console.warn(slides_en_link)
				// console.warn(slides_sp_link)

				// translate from lesson_code to lesson hcs
				// sample lesson codes: `G1_U1_L6`, `G10_U1a_L1`

				let hcs = []

				hcs.push(lesson_code)

				let carr = lesson_code.split('_')
				if (carr.length > 1) {
					// skip initial "GX" if there
					if (carr[0][0] == 'G') carr.shift()

					let unit_n = carr[0].replace(/^U(.*)/i, '$1')		// 1 or 1a
					let lesson_n = carr[1].replace(/^L(.*)/i, '$1')		// 6 or 1

					hcs.push(`${unit_n}.${lesson_n}`)
					hcs.push(`${unit_n.replace(/(\d+)(.*)/, '$1.$2')}.${lesson_n}`)
				}
				// NOTE: we might need to add additional options here

				// hopefully we find a single lesson 
				let farr = darr.filter(x => {
					let hc = (x.humanCodingScheme || '').trim()
					if (hcs.includes(hc)) return true

					// ===== OPTIONAL: match 3-part numeric HCS "a.b.c" using "a.c" so that Don's Spreadsheet still works=====
					// Comment out this whole block to revert to original matching behavior.
					// let parts = hc.split('.')
					// if (parts.length == 3 && parts.every(p => /^\d+$/.test(p))) {
					// 	let firstThird = `${parts[0]}.${parts[2]}`  // e.g. "1.2.3" -> "1.3"
					// 	if (hcs.includes(firstThird)) return true
					// }
					// ===== END OPTIONAL BLOCK =====

					return false
				})
				if (farr.length == 0) {
					return (`No Lesson found for entered code “${lesson_code}” (${hcs.join(', ')})`)
				} else if (farr.length > 1) {
					return (`Multiple Lessons found for entered code “${lesson_code}” (${farr[0].humanCodingScheme} ${farr[0].fullStatement}`)
				}
				let item = farr[0]

				// If the lesson doesn't have a real title yet, append the parent fullStatement "Lesson 1" becomes "Lesson 1: My Community in the World"
				let fullStatement = (item.fullStatement || '').replace(/\s+/g, ' ').trim()
				if (/^Lesson [\w.]+$/.test(fullStatement)) {
					let parent_fs = (parent_fs_by_lesson_id[item.identifier] || '').replace(/\s+/g, ' ').trim()
					
					if (!empty(parent_fs)) {
						fullStatement = `${fullStatement}: ${parent_fs}`
					} else {
						console.warn(`CPS prescript ${line_number}: Lesson matched placeholder title but has no parent fullStatement: ${item.humanCodingScheme} ${item.fullStatement}`)
					}
				}
				// console.warn(`found Lesson ${item.humanCodingScheme} ${item.fullStatement}`)

				// compose SatchelScript for this update, starting with the base line for the item, including the identifier
				output.push(`Lesson * {${item.identifier}} :${item.humanCodingScheme} ${fullStatement}`)

				// tfg, en slide, and sp slide links
				let report = ''
				if (!empty(tfg_link)) { output.push(`EXT-tfgURL: ${tfg_link}`); report += ' TFG'; }
				if (!empty(slides_en_link)) { output.push(`EXT-slideURL_EN: ${slides_en_link}`); report += ' Slides-EN'; }
				if (!empty(slides_sp_link)) { output.push(`EXT-slideURL_SP: ${slides_sp_link}`); report += ' Slides-SP'; }
				/*
				Lesson * {0290b5ee-3440-406e-93bf-da492f589630} :1.1 Lesson 1
				EXT-tfgURL: https://docs.google.com/document/d/12TOxcONsRCcmgCvOGZi-TOwm3FAxDZRkLzLaptM1zXw/edit?usp=drivesdk
				EXT-slideURL_EN: https://docs.google.com/presentation/d/1GAk-NU9RKJ1e_mLiDjC-imaC43zA0MtSguX4aLG6jrY/edit?usp=drivesdk
				*/

				console.log(`CPS prescript ${line_number}: Added to Lesson ${item.humanCodingScheme}: ${report}`)
				// if (line_number > 1) break
			}

			if (output.length == 0) {
				return `No processable lines found`
			}

			return output
		},

		async pre_script_cps_tfg_lesson_data(lines, log) {
			// This pre-script should be run from an existing branch of a framework. 
			// Here we pull data from an attached TFG google docs and use it to update lesson CFItems

			// Note that the server must have the Google apiclient library installed, and must have appropriate CFG lines set,
			// so that the script can load the google docs

			// this prescript requires the following settings:
			this.no_hierarchy = true
			this.convert_newlines_to_spaces = true
			this.parse_algo = 'algo1'

			// get all descendent Lessons for the currently-selected item in the tree
			let active_node = this.editor_component.viewer.active_node
			let branch = this.editor_component.viewer.cfo.tree_nodes_hash[active_node]

			let darr = []
			let get_descendents = (node) => {
				if (node.cfitem.CFItemType == 'Lesson') {
					darr.push(node.cfitem)
				}

				for (let child of node.children) {
					get_descendents(child)
				}
			}
			get_descendents(branch)
			
			if (darr.length == 0) {
				return ('No Lessons found in the active branch')
			}

			let output = []

			// go through each lesson cfitem
			let line_number = 0
			for (let item of darr) {
				++line_number
				let fullStatement = item.fullStatement
				let tfg_url = item.extensions?.tfgURL
				// console.warn(`found Lesson ${item.humanCodingScheme} ${fullStatement}: ${tfg_url}`)

				// if we don't have a tfg link, we can't do anything
				if (empty(tfg_url)) {
					log.push(`${line_number}: No TFG URL for ${item.humanCodingScheme} ${fullStatement}`)
					continue
				}

				// if the lesson doesn't have a title, look for on
				if (/^Lesson [\w.]+$/.test(fullStatement)) {
					// TODO: Get the parent of this lesson (the Unit) item.parent_node.cfitem.fullStatement to creat fullStatement- Nick added this feature to pre_script_cps_tfg_link function
					let payload = {
						drive_url: tfg_url,
						mime_type: 'text/plain',
					}
					U.loading_start('Reading TFG for ' + fullStatement)
					let tfg_contents = await U.get_from_google_drive_async(payload)
					U.loading_stop()

					// if we get an error reading the doc, return
					if (tfg_contents === false) {
						//return `${line_number}: Error reading TFG; see console for details: ${item.humanCodingScheme} ${fullStatement}`
						log.push(`${line_number}: Error reading TFG; see console for details: ${item.humanCodingScheme} ${fullStatement}`)
						continue
					}

					// look for the lesson title
					if (tfg_contents.search(/Unit\s*[\w.]+\s*:\s*Lesson\s*[\w.]+\s*:\s*(.+)/) > -1) {
						let lesson_title = RegExp.$1
						log.push(`${line_number}: Extracted lesson title: ${fullStatement} ${lesson_title}`)
						fullStatement = `${fullStatement}: ${lesson_title}`

						// compose SatchelScript for this update, starting with the base line for the item, including the identifier
						output.push(`Lesson * {${item.identifier}} :${item.humanCodingScheme} ${fullStatement}`)

					} else {
						// if we can't extract a title...
						// return `${line_number}: Lesson title could not be extracted from TFG: ${item.humanCodingScheme} ${fullStatement}`

						// if we can't extract a title, log and continue
						log.push(`${line_number}: Lesson title could not be extracted from TFG: ${item.humanCodingScheme} ${fullStatement}`)
						continue
					}
					// window.gd_contents.search(/Unit\s*[\w.]+\s*:\s*Lesson\s*[\w.]+\s*:\s*(.+)/); window.gd_lesson_title = RegExp.$1

				} else {
					// the lesson already has a title, so report this and continue
					log.push(`${line_number}: Lesson already has title: ${item.humanCodingScheme} ${fullStatement}`)
					continue
				}
			}

			if (output.length == 0) {
				return `No processable lines found`
			}

			return output
		},

		// MC: Asked ChatGPT to translate my python script into Javascript
		pre_script_australia(data) {
			data = JSON.parse(data)[0]
			const parent_to_children = new Map()
			const child_to_parent = new Map()
			const node_map = new Map()
			const missing_children = []

			// Optional config to show all HRCs
			const show_all_notations = false

			// Populate node_map
			for (const item of data['@graph']) {
				if ('@id' in item) {
					node_map.set(item['@id'], item)
				}
			}

			// Build child_to_parent
			for (const item of data['@graph']) {
				const item_id = item['@id']
				const parents = item['http://purl.org/gem/qualifiers/isChildOf'] || []
				for (const parent_ref of parents) {
					const parent_id = parent_ref['@id']
					if (parent_id) {
						child_to_parent.set(item_id, parent_id)
					}
				}
			}

			// Build parent_to_children
			for (const item of data['@graph']) {
				const item_id = item['@id']
				const children = item['http://purl.org/gem/qualifiers/hasChild'] || []
				for (const child_ref of children) {
					const child_id = child_ref['@id']
					if (child_id) {
						if (!parent_to_children.has(item_id)) parent_to_children.set(item_id, [])
						parent_to_children.get(item_id).push(child_id)
					}
				}
			}

			// Identify missing children
			for (const [child_id, parent_id] of child_to_parent.entries()) {
				const children = parent_to_children.get(parent_id) || []
				if (!children.includes(child_id)) {
					missing_children.push({ parent_id, child_id })
				}
			}

			// Build missing_children_map
			const missing_children_map = new Map()
			for (const entry of missing_children) {
				const list = missing_children_map.get(entry.parent_id) || []
				list.push(entry.child_id)
				missing_children_map.set(entry.parent_id, list)
			}

			// Roots are nodes that are parents but not children
			const roots = Array.from(parent_to_children.keys()).filter(node_id => !child_to_parent.has(node_id))

			function get_value(item, key) {
				const values = item[key] || []
				if (Array.isArray(values) && values.length > 0) {
					return values[0]['@value'] || values[0]['@id'] || null
				}
				return null
			}

			function build_tree(node_id, source = null) {
				const node = node_map.get(node_id) || {}
				const children = []
				const orphaned = []

				for (const child_id of parent_to_children.get(node_id) || []) {
					const child_node = build_tree(child_id)
					if (child_to_parent.get(child_id) === node_id) {
						children.push(child_node)
					} else {
						orphaned.push(child_node)
					}
				}

				for (const missing_id of missing_children_map.get(node_id) || []) {
					const missing_node = build_tree(missing_id, 'missing')
					children.push(missing_node)
				}

				children.sort((a, b) => (a.list_id === null) - (b.list_id === null) || a.list_id - b.list_id)
				orphaned.sort((a, b) => (a.list_id === null) - (b.list_id === null) || a.list_id - b.list_id)

				const list_id_raw = get_value(node, 'http://purl.org/ASN/schema/core/listID')

				const return_node = {
					id: node_id,
					statement_label: get_value(node, 'http://purl.org/ASN/schema/core/statementLabel'),
					statement_notation: get_value(node, 'http://purl.org/ASN/schema/core/statementNotation'),
					title:
            get_value(node, 'http://purl.org/dc/terms/title') ||
            get_value(node, 'http://purl.org/dc/terms/description'),
					education_level: get_value(node, 'http://purl.org/dc/terms/educationLevel'),
					list_id: list_id_raw !== null ? parseInt(list_id_raw, 10) : null,
					children
				}

				if (source === 'missing') return_node.source = 'missing'
				if (orphaned.length > 0) return_node.missing_children = orphaned

				return return_node
			}

			const forest = roots.map(build_tree)

			// Formatter helpers
			function prefix_title(label, title) {
				if (!title) return ''
				if (label === 'Content Description') return `*Students learn to* ${title}`
				if (label === 'Elaboration') return `*This may involve students* ${title}`
				return title
			}

			function collect_notes_from_node_safe(node) {
				const notes = []

				for (const child of node.children || []) {
					if (typeof child === 'object') {
						const label = child.statement_label
						if (typeof label === 'string' && label.toLowerCase() === 'elaboration') {
							if (child.title) {
								notes.push(`- ${prefix_title(label, child.title)}`)
							}
						}
					}
				}

				for (const child of node.children || []) {
					if (typeof child === 'object' && child.source === 'missing') {
						for (const grandchild of child.children || []) {
							if (typeof grandchild === 'object' && grandchild.title) {
								notes.push(`- ${prefix_title(grandchild.statement_label, grandchild.title)}`)
							}
						}
					}
				}

				return notes
			}

			function format_tree_with_notes_final_safe(node, level = 1) {
				const lines = []
				const stars = '*'.repeat(level)

				const label = node.statement_label || 'Unknown_Label'
				const label_display = label.replace(/\s+/g, '_')
				const title = prefix_title(label, node.title || '')
				const notation =
					!show_all_notations && ['Content Description', 'Elaboration'].indexOf(label) === -1
						? ''
						: node.statement_notation || ''

				lines.push(`${label_display} ${stars}${notation ? ' :' + notation : ''} ${title}`.trim())

				const notes = collect_notes_from_node_safe(node)
				if (notes.length > 0) {
					lines.push('NOTES:')
					lines.push(...notes)
				}

				for (const child of node.children || []) {
					const sl = child.statement_label
					if ((typeof sl !== 'string' || sl.toLowerCase() !== 'elaboration') && child.source !== 'missing') {
						lines.push(...format_tree_with_notes_final_safe(child, level + 1))
					}
				}

				return lines
			}

			const final_output_lines = []
			for (const tree of forest) {
				final_output_lines.push(...format_tree_with_notes_final_safe(tree))
			}

			return final_output_lines
		},

		async pre_script_resource_full_text_import(lines) {
			let sections = []
			let found_chapter = false
			let chapter_title = ''
			let current_section = null

			function add_section(arr, section) {
				arr.push(`Learning_Resource ** :${section.hcs} ${section.statement}`)
				arr.push('EXT-fullContent:')

				for (let content_line of section.full_content_lines) {
					arr.push(content_line)
				}
			}

			let arr = []
			let line_number = 0
			for (let line of lines) {
				++line_number
				line = $.trim(line)

				// Keep blank lines out of the generated SatchelScript
				if (empty(line)) continue

				// Chapter title lines start with '* Chapter ' + digits followed by a space
				// Example: 2 Cell Structure
				if (line.search(/^\* Chapter (\d+)\s+(.*)$/) == 0) {
					let hcs = RegExp.$1
					let chapter_title = RegExp.$2

					// add just-processed section if we have one
					if (!empty(current_section)) add_section(arr, current_section)
					current_section = null

					// add line for chapter
					arr.push(`Chapter * :${hcs} ${chapter_title}`)
					console.log('* Chapter: ' + chapter_title)
					continue
				}

				// section title lines start with digits.period.digits followed by a space
				// Example: 11.1 Testing Structure in a Closed Environment
				if (line.search(/^(\d+\.\d+)\s+(.*)$/) == 0) {
					let hcs = RegExp.$1
					let statement = RegExp.$2

					// add just-processed section if we have one
					if (!empty(current_section)) add_section(arr, current_section)

					current_section = {
						hcs,
						statement,
						title: `${hcs} ${statement}`,
						full_content_lines: [],
						description: ''
					}

					console.log('** Section: ' + current_section.title)
					continue
				}

				// All other lines belong to the current section's fullContent
				if (current_section) {
					current_section.full_content_lines.push(line)
				} else {
					console.error(`line ${line_number}: no current_section to add to`)
				}
			}

			// add last-processed section if we have one
			if (!empty(current_section)) add_section(arr, current_section)

			return arr
		},

		async pre_script_resource_summary_import(lines) {
			let textbook_title = await U.prompt_promise({
				title: 'Textbook Title',
				text: 'Enter the textbook title to use for the Resource Summary Import AI prompt.',
				promptType: 'text',
				acceptText: 'Continue',
				cancelText: 'Cancel',
			})

			// If the user cancels, stop the import using existing pre-script error handling.
			// Blank string should still continue.
			if (textbook_title === false || textbook_title === null || typeof textbook_title == 'undefined') {
				return 'Import canceled.'
			}

			textbook_title = $.trim(textbook_title)

			let sections = []
			let found_chapter = false
			let chapter_title = ''
			let current_section = null

			for (let line of lines) {
				line = $.trim(line)

				// Keep blank lines out of the generated SatchelScript
				if (empty(line)) continue

				// First non-empty line becomes the Chapter
				if (!found_chapter) {
					chapter_title = line
					found_chapter = true
					continue
				}

				// Resource title lines start with digits.period.digits followed by a space
				// Example: 11.1 Testing Structure in a Closed Environment
				if (line.search(/^(\d+\.\d+)\s+(.*)$/) == 0) {
					let hcs = RegExp.$1
					let statement = RegExp.$2

					current_section = {
						hcs,
						statement,
						title: `${hcs} ${statement}`,
						full_content_lines: [],
						description: ''
					}
					sections.push(current_section)

					continue
				}

				// All other lines belong to the current section's fullContent
				if (current_section) {
					current_section.full_content_lines.push(line)
				}
			}

			console.log('Resource Summary Import textbook title:', textbook_title)
			console.log('Resource Summary Import chapter title:', chapter_title)
			console.log('Resource Summary Import sections:', sections)

			// Run the AI call for every resource section before building the final SatchelScript output.
			if (sections.length > 0) {
				U.loading_start()

				try {
					for (let i = 0; i < sections.length; ++i) {
						let section = sections[i]
						let ai_prompt = this.build_resource_summary_ai_prompt(textbook_title, chapter_title, section)

						console.log(`Resource Summary Import AI section ${i + 1} of ${sections.length}:`, section.title)

						let result = await this.run_resource_summary_prompt_with_retry(ai_prompt, section.title)

						console.log(`Resource Summary Import AI result for ${section.title}:`, result)

						if (result && result.status === 'ok') {
							section.description = result.response || ''
						} else {
							let error_text = result && result.status ? result.status : 'Unknown error'
							section.description = `AI summary failed: ${error_text}`
						}
					}
				} finally {
					U.loading_stop()
				}
			}

			// Build the final SatchelScript output after the AI response is available
			let arr = []

			if (!empty(chapter_title)) {
				arr.push(`Chapter * :${chapter_title}`)
			}

			for (let section of sections) {
				arr.push(`Section ** :${section.hcs} ${section.statement}`) // changed from Learning_Resource to Section
				arr.push('EXT-fullContent:')

				for (let content_line of section.full_content_lines) {
					arr.push(content_line)
				}

				if (!empty(section.description)) {
					arr.push('EXT-description:')
					arr.push(section.description)
				}
			}

			return arr
		},

		////////////////////////////////////////
		// gemini methods and helpers to support the resource summary import prescript
		build_resource_summary_ai_prompt(textbook_title, chapter_title, section) {
			let full_content = section.full_content_lines.join('\n').trim()

			return `You are an educational data analyst. Your task is to summarize the attached text from the textbook [TEXTBOOK_TITLE], specifically the section titled [SECTION_TITLE], distilling the text down to its essential concepts, themes, or skills.

Generate a prose summary of approximately 75 words using the following structural guidelines:

* State the content directly and declaratively. Describe the core ideas, processes, techniques, or relationships as established facts.

* Omit all learner-facing meta-language. Do not include references to the student, reader, or classroom expectations (explicitly avoid phrases like "Students must analyze," "Students will understand," "Mastery requires," or "The reader learns").

* Prioritize domain-specific academic vocabulary and the central concepts, frameworks, or methodologies introduced in the text.

* Do not write a bulleted list; instead, synthesize the content into a single, high-density paragraph of continuous prose.

* Avoid meta-commentary about the book itself (e.g., omit phrases like "In this section, the authors explain...").

Textbook Title: ${textbook_title}
Chapter Title: ${chapter_title}

<text_to_summarize>
${section.title}

${full_content}
</text_to_summarize>`
		},

		resource_summary_sleep(ms) {
			return new Promise(resolve => setTimeout(resolve, ms))
		},

		resource_summary_schema() {
			return JSON.stringify({
				type: 'object',
				properties: {
					output: {
						type: 'string'
					}
				},
				required: ['output'],
				additionalProperties: false
			})
		},

		resource_summary_should_retry_prompt_result(result) {
			if (!result) return true
		
			let text = ''
		
			if (typeof result === 'string') {
				text = result
			} else {
				text = [
					result.status,
					result.response,
					result.message,
					result.error,
				].filter(Boolean).join(' ')
			}
		
			text = String(text).toLowerCase()
		
			return (
				text.includes('503') ||
				text.includes('service unavailable') ||
				text.includes('overloaded') ||
				text.includes('unavailable') ||
				text.includes('try again later')
			)
		},

		resource_summary_prompt_ajax(payload) {
			return new Promise(resolve => {
				try {
					U.ajax('gemini_query', payload, result => {
						resolve(result)
					})
				} catch (e) {
					console.warn('Resource Summary Import gemini_query error', e)
					resolve(false)
				}
			})
		},

		async run_resource_summary_prompt_with_retry(prompt, runLabel = 'resource summary') {
			const max_attempts = 4
			const delay_ms = 3000

			let last_result = null

			for (let attempt = 1; attempt <= max_attempts; ++attempt) {
				console.log(`AI ${runLabel} attempt ${attempt} of ${max_attempts}`)

				let payload = {
					prompt,
					//model: 'gemini-3-flash-preview',
					model: 'gemini-3.5-flash-lite',
					temperature: 1,
					thinking_level: 'LOW',
					schema: this.resource_summary_schema(),
					response_property: 'output',
					force_reprocess_files: false,
				}

				last_result = await this.resource_summary_prompt_ajax(payload)

				if (last_result && last_result.status === 'ok') {
					return last_result
				}

				if (!this.resource_summary_should_retry_prompt_result(last_result) || attempt === max_attempts) {
					return last_result
				}

				console.warn(`Retrying AI ${runLabel} after transient error`, last_result)
				await this.resource_summary_sleep(delay_ms)
			}

			return last_result
		},

		resource_add_item(contents) {
			//console.log('resource_add_item start')

			this.raw_text_for_import = contents
			this.resource_ai_import_interface_showing = false

			this.$nextTick(() => {
				//console.log('inside nextTick')

				this.import_children()
			})
		},

		////////////////////////////////////////
		// post scripts: these can run after the import script has run
		post_script_ccsd_unit(data) {
			let find_descendent_by_hcs = (parent_node, hcs) => {
				for (let child of parent_node.children) {
					if (child.cfitem.humanCodingScheme == hcs) {
						return child
					}
					if (child.children.length > 0) {
						let rv = find_descendent_by_hcs(child, hcs)
						if (rv) return rv
					}
				}
				return null
			}

			console.log('post_script_ccsd unit', data)
			let errors = []
			let framework_record = this.editor_component.framework_record
			let cfo = framework_record.cfo
			let cfdocument = this.editor_component.CFDocument
			let original_node = this.editor_component.original_node
			let original_cfitem = original_node.cfitem

			let current_unit = null
			let current_unit_number = 'XXX'
			let sequence = 0
			for (let ii = 0; ii < data.CFItems.length; ++ii) {
				let item = data.CFItems[ii]
				// when we encounter a unit, set current_unit
				if (item.CFItemType == 'Unit') {
					current_unit = item
					sequence = 0
					current_unit_number = item.humanCodingScheme.replace(/.*\.U(\w+)$/, '$1')
					if (current_unit_number == item.humanCodingScheme) {
						errors.push(sr('Couldn’t find unit number for: ' + item.humanCodingScheme + ': ' + item.fullStatement))
						current_unit_number = 'XXX'
					}
					continue
				}

				++sequence

				// Place LFs under appropriate standards, and fill in unit numbers
				if (item.CFItemType == 'Learning Focus') {
					// get the isChildOf association
					let assoc = data.CFAssociations.find(x => x.originNodeURI.identifier == item.identifier)

					// get the node for the child item -- there should only be one
					let child_node = cfo.cfitems[item.identifier].tree_nodes[0]

					// replace the unit number if necessary
					if (item.humanCodingScheme && item.humanCodingScheme.search(/UX+/) > -1) {
						console.log('replacing unit number: ' + current_unit_number)
						assoc.originNodeURI.title = assoc.originNodeURI.title.replace(/UX+/, 'U' + current_unit_number)
						item.humanCodingScheme = item.humanCodingScheme.replace(/UX+/, 'U' + current_unit_number)
						this.$store.commit('set', [child_node.cfitem, 'humanCodingScheme', item.humanCodingScheme])
						console.log('replacing unit number: ' + current_unit_number + ': ' + assoc.originNodeURI.title)
					}

					// find the corresponding competency in the parent folder
					let parent_hcs = item.humanCodingScheme.replace(/\.LF\b.*/, '')
					let parent_node = find_descendent_by_hcs(original_node, parent_hcs)
					// console.log(sr('$3: $1 / $2', item.humanCodingScheme, parent_hcs, parent_node ? parent_node.humanCodingScheme : '???'))
					if (!parent_node) {
						errors.push(sr('Couldn’t find parent of item with HCS <b>$1</b> ($2)', item.humanCodingScheme, parent_hcs))
						continue
					}

					// if the parent already has a child with this hcs, delete this item -- this happens for standards that are repeated in different units
					if (parent_node.children.find(x => x.cfitem.humanCodingScheme == item.humanCodingScheme)) {
						console.log('deleting duplicate: ' + item.humanCodingScheme)
						let index = data.CFAssociations.findIndex(x => x == assoc)
						data.CFAssociations.splice(index, 1)
						// remove the item from data.CFItems, then adjust ii
						data.CFItems.splice(ii, 1)
						--ii
						U.delete_node_from_cfo(cfo, child_node, true)
						continue
					}

					// switch the association to be a child of this parent
					assoc.destinationNodeURI.title = U.generate_cfassociation_node_uri_title(parent_node.cfitem);
					(assoc.destinationNodeURI.identifier = parent_node.cfitem.identifier),
					(assoc.destinationNodeURI.uri = parent_node.cfitem.uri)

					// if the parent is a standard, we want the LF to be the first child
					if (parent_node.cfitem.CFItemType.includes('Standard')) {
						assoc.sequenceNumber = 1
						// remove the original_node from its previous parent's children, then add the node to the new parent's children array
						U.delete_node_from_cfo(cfo, child_node, true)
						U.add_child_to_cfo(child_node.cfitem, parent_node, this.$store, cfo, 0)

						// go through all this parent_node's other children save updates to the sequenceNumbers
						for (let i = 0; i < parent_node.children.length; ++i) {
							let cn = parent_node.children[i]

							// update the child's CFAssociation sequence and save to data
							let index = U.find_cfassociation_index(
								framework_record.json.CFAssociations,
								cn.cfitem.identifier,
								cn.parent_node.cfitem.identifier
							)
							if (index > -1) {
								// note that we save sequenceNumber as i+2, since the new item is child #1
								this.$store.commit('set', [framework_record.json.CFAssociations[index], 'sequenceNumber', i + 2])
								data.CFAssociations.push(new CFAssociation(framework_record.json.CFAssociations[index]).to_json())
							}
						}

						// else we want the LF to be the last child
					} else {
						assoc.sequenceNumber = U.get_next_sequenceNumber(parent_node, framework_record)
						// remove the original_node from its previous parent's children, then add the node to the new parent's children array
						U.delete_node_from_cfo(cfo, child_node, true)
						U.add_child_to_cfo(child_node.cfitem, parent_node, this.$store, cfo, assoc.sequenceNumber)
					}
				}

				// if current_unit isn't null, add isPartOf relation between the item to the unit
				if (current_unit) {
					data.CFAssociations.push(U.create_association(current_unit, item, sequence, cfdocument, 'isPartOf'))
				}
			}

			// Place the Units in the Units folder
			let unit_folder_node
			for (let item of data.CFItems) {
				if (item.fullStatement == 'Units') {
					unit_folder_node = cfo.cfitems[item.identifier].tree_nodes[0]
					continue
				}
				if (item.CFItemType == 'Unit') {
					// get the isChildOf association
					let assoc = data.CFAssociations.find(x => x.originNodeURI.identifier == item.identifier)

					// switch the association to be a child of this parent, and update the sequenceNumber
					assoc.destinationNodeURI.title = U.generate_cfassociation_node_uri_title(unit_folder_node.cfitem);
					(assoc.destinationNodeURI.identifier = unit_folder_node.cfitem.identifier),
					(assoc.destinationNodeURI.uri = unit_folder_node.cfitem.uri)
					assoc.sequenceNumber = U.get_next_sequenceNumber(unit_folder_node, framework_record)

					// remove the original_node from its previous parent's children, then add the node to the new parent's children array
					let unit_node = cfo.cfitems[item.identifier].tree_nodes[0]
					U.delete_node_from_cfo(cfo, unit_node, true)
					U.add_child_to_cfo(unit_node.cfitem, unit_folder_node, this.$store, cfo, assoc.sequenceNumber)
				}
			}

			// Place the top-level standards items in the Standards folder
			for (let item of data.CFItems) {
				if (item.fullStatement == 'Standards') {
					let standards_folder_node = cfo.cfitems[item.identifier].tree_nodes[0]

					// go through all children of the original node
					let sn = 0
					for (let i = 0; i < original_node.children.length; ++i) {
						let child_node = original_node.children[i]

						// skip Units and Standards folders
						if (child_node.cfitem.fullStatement == 'Standards' || child_node.cfitem.fullStatement == 'Units') continue

						let index = U.find_cfassociation_index(
							framework_record.json.CFAssociations,
							child_node.cfitem.identifier,
							child_node.parent_node.cfitem.identifier
						)
						if (index != -1) {
							++sn

							// don't bother updating json association; we're instructing the operator to reload right after we save
							let assoc = new CFAssociation(framework_record.json.CFAssociations[index])
							assoc.destinationNodeURI.title = U.generate_cfassociation_node_uri_title(standards_folder_node.cfitem);
							(assoc.destinationNodeURI.identifier = standards_folder_node.cfitem.identifier),
							(assoc.destinationNodeURI.uri = standards_folder_node.cfitem.uri)
							assoc.sequenceNumber = sn
							data.CFAssociations.push(assoc.to_json())

							U.delete_node_from_cfo(cfo, child_node, true)
							U.add_child_to_cfo(
								child_node.cfitem,
								standards_folder_node,
								this.$store,
								cfo,
								assoc.sequenceNumber,
								child_node.children
							)

							// decrement i, because we just took an item out of original_node.children
							--i
						} else {
							console.log('Yikes!')
						}
					}

					break
				}
			}

			console.log('post_script_ccsd unit - after', data)

			if (errors.length > 0) {
				this.$alert({
					title: 'Post-Script possible errors',
					text: sr('<div style="font-size:12px">$1</div>', errors.join('<br>')),
					dialogMaxWidth: 950
				})
			} else {
				this.$alert('Post-Script successful. Please reload after reviewing and saving imported items.')
			}
		},

		post_script_ccsd_module(data) {
			let find_descendent_by_hcs = (parent_node, hcs) => {
				for (let child of parent_node.children) {
					if (child.cfitem.humanCodingScheme == hcs) {
						return child
					}
					if (child.children.length > 0) {
						let rv = find_descendent_by_hcs(child, hcs)
						if (rv) return rv
					}
				}
				return null
			}

			console.log('post_script_ccsd module', data)
			let errors = []
			let framework_record = this.editor_component.framework_record
			let cfo = framework_record.cfo
			let cfdocument = this.editor_component.CFDocument
			let original_node = this.editor_component.original_node
			let original_cfitem = original_node.cfitem

			let current_unit = null
			let current_unit_number = 'XXX'
			let sequence = 0
			for (let ii = 0; ii < data.CFItems.length; ++ii) {
				let item = data.CFItems[ii]
				// when we encounter a unit, set current_unit
				if (item.CFItemType == 'Module') {
					current_unit = item
					sequence = 0
					current_unit_number = item.humanCodingScheme.replace(/.*\.M(\w+)$/, '$1')
					if (current_unit_number == item.humanCodingScheme) {
						errors.push(
							sr('Couldn’t find unit/module number for: ' + item.humanCodingScheme + ': ' + item.fullStatement)
						)
						current_unit_number = 'XXX'
					}
					continue
				}

				++sequence

				// Place LFs under appropriate standards, and fill in unit numbers
				if (item.CFItemType == 'Learning Focus') {
					// get the isChildOf association
					let assoc = data.CFAssociations.find(x => x.originNodeURI.identifier == item.identifier)

					// get the node for the child item -- there should only be one
					let child_node = cfo.cfitems[item.identifier].tree_nodes[0]

					// replace the unit number if necessary
					if (item.humanCodingScheme && item.humanCodingScheme.search(/MX+/) > -1) {
						console.log('replacing unit number: ' + current_unit_number)
						assoc.originNodeURI.title = assoc.originNodeURI.title.replace(/MX+/, 'M' + current_unit_number)
						item.humanCodingScheme = item.humanCodingScheme.replace(/MX+/, 'M' + current_unit_number)
						this.$store.commit('set', [child_node.cfitem, 'humanCodingScheme', item.humanCodingScheme])
						console.log('replacing unit number: ' + current_unit_number + ': ' + assoc.originNodeURI.title)
					}

					// find the corresponding competency in the parent folder
					let parent_hcs = item.humanCodingScheme.replace(/\.LF\b.*/, '')
					let parent_node = find_descendent_by_hcs(original_node, parent_hcs)
					// console.log(sr('$3: $1 / $2', item.humanCodingScheme, parent_hcs, parent_node ? parent_node.humanCodingScheme : '???'))
					if (!parent_node) {
						errors.push(sr('Couldn’t find parent of item with HCS <b>$1</b> ($2)', item.humanCodingScheme, parent_hcs))
						continue
					}

					// if the parent already has a child with this hcs, delete this item -- this happens for standards that are repeated in different units
					if (parent_node.children.find(x => x.cfitem.humanCodingScheme == item.humanCodingScheme)) {
						console.log('deleting duplicate: ' + item.humanCodingScheme)
						let index = data.CFAssociations.findIndex(x => x == assoc)
						data.CFAssociations.splice(index, 1)
						// remove the item from data.CFItems, then adjust ii
						data.CFItems.splice(ii, 1)
						--ii
						U.delete_node_from_cfo(cfo, child_node, true)
						continue
					}

					// switch the association to be a child of this parent
					assoc.destinationNodeURI.title = U.generate_cfassociation_node_uri_title(parent_node.cfitem);
					(assoc.destinationNodeURI.identifier = parent_node.cfitem.identifier),
					(assoc.destinationNodeURI.uri = parent_node.cfitem.uri)

					// if the parent is a standard, we want the LF to be the first child
					if (parent_node.cfitem.CFItemType.includes('Standard')) {
						assoc.sequenceNumber = 1
						// remove the original_node from its previous parent's children, then add the node to the new parent's children array
						U.delete_node_from_cfo(cfo, child_node, true)
						U.add_child_to_cfo(child_node.cfitem, parent_node, this.$store, cfo, 0)

						// go through all this parent_node's other children save updates to the sequenceNumbers
						for (let i = 0; i < parent_node.children.length; ++i) {
							let cn = parent_node.children[i]

							// update the child's CFAssociation sequence and save to data
							let index = U.find_cfassociation_index(
								framework_record.json.CFAssociations,
								cn.cfitem.identifier,
								cn.parent_node.cfitem.identifier
							)
							if (index > -1) {
								// note that we save sequenceNumber as i+2, since the new item is child #1
								this.$store.commit('set', [framework_record.json.CFAssociations[index], 'sequenceNumber', i + 2])
								data.CFAssociations.push(new CFAssociation(framework_record.json.CFAssociations[index]).to_json())
							}
						}

						// else we want the LF to be the last child
					} else {
						assoc.sequenceNumber = U.get_next_sequenceNumber(parent_node, framework_record)
						// remove the original_node from its previous parent's children, then add the node to the new parent's children array
						U.delete_node_from_cfo(cfo, child_node, true)
						U.add_child_to_cfo(child_node.cfitem, parent_node, this.$store, cfo, assoc.sequenceNumber)
					}
				}

				// if current_unit isn't null, add isPartOf relation between the item to the unit
				if (current_unit) {
					data.CFAssociations.push(U.create_association(current_unit, item, sequence, cfdocument, 'isPartOf'))
				}
			}

			// Place the Units in the Units folder
			let unit_folder_node
			for (let item of data.CFItems) {
				if (item.fullStatement == 'Modules') {
					unit_folder_node = cfo.cfitems[item.identifier].tree_nodes[0]
					continue
				}
				if (item.CFItemType == 'Module') {
					// get the isChildOf association
					let assoc = data.CFAssociations.find(x => x.originNodeURI.identifier == item.identifier)

					// switch the association to be a child of this parent, and update the sequenceNumber
					assoc.destinationNodeURI.title = U.generate_cfassociation_node_uri_title(unit_folder_node.cfitem);
					(assoc.destinationNodeURI.identifier = unit_folder_node.cfitem.identifier),
					(assoc.destinationNodeURI.uri = unit_folder_node.cfitem.uri)
					assoc.sequenceNumber = U.get_next_sequenceNumber(unit_folder_node, framework_record)

					// remove the original_node from its previous parent's children, then add the node to the new parent's children array
					let unit_node = cfo.cfitems[item.identifier].tree_nodes[0]
					U.delete_node_from_cfo(cfo, unit_node, true)
					U.add_child_to_cfo(unit_node.cfitem, unit_folder_node, this.$store, cfo, assoc.sequenceNumber)
				}
			}

			// Place the top-level standards items in the Standards folder
			for (let item of data.CFItems) {
				if (item.fullStatement == 'Standards') {
					let standards_folder_node = cfo.cfitems[item.identifier].tree_nodes[0]

					// go through all children of the original node
					let sn = 0
					for (let i = 0; i < original_node.children.length; ++i) {
						let child_node = original_node.children[i]

						// skip Units and Standards folders
						if (child_node.cfitem.fullStatement == 'Standards' || child_node.cfitem.fullStatement == 'Modules')
							continue

						let index = U.find_cfassociation_index(
							framework_record.json.CFAssociations,
							child_node.cfitem.identifier,
							child_node.parent_node.cfitem.identifier
						)
						if (index != -1) {
							++sn

							// don't bother updating json association; we're instructing the operator to reload right after we save
							let assoc = new CFAssociation(framework_record.json.CFAssociations[index])
							assoc.destinationNodeURI.title = U.generate_cfassociation_node_uri_title(standards_folder_node.cfitem);
							(assoc.destinationNodeURI.identifier = standards_folder_node.cfitem.identifier),
							(assoc.destinationNodeURI.uri = standards_folder_node.cfitem.uri)
							assoc.sequenceNumber = sn
							data.CFAssociations.push(assoc.to_json())

							U.delete_node_from_cfo(cfo, child_node, true)
							U.add_child_to_cfo(
								child_node.cfitem,
								standards_folder_node,
								this.$store,
								cfo,
								assoc.sequenceNumber,
								child_node.children
							)

							// decrement i, because we just took an item out of original_node.children
							--i
						} else {
							console.log('Yikes!')
						}
					}

					break
				}
			}

			console.log('post_script_ccsd module - after', data)

			if (errors.length > 0) {
				this.$alert({
					title: 'Post-Script possible errors',
					text: sr('<div style="font-size:12px">$1</div>', errors.join('<br>')),
					dialogMaxWidth: 950
				})
			} else {
				this.$alert('Post-Script successful. Please reload after reviewing and saving imported items.')
			}
		},
	}
}
</script>

<style lang="scss">
.k-case-item-importer {
  textarea {
    font-size: 12px;
    line-height: 16px !important;
    max-height: calc(100vh - 450px);
  }
}

// the below styles are also used for ItemCopyInterface
.k-case-item-importer-report {
  overflow: auto;
}

.k-case-item-importer-report-inner {
  white-space: nowrap;
  font-size: 12px;
  line-height: 14px;
}

.k-case-item-importer-raw-text-area {
  margin-bottom: 8px;
  textarea {
    overflow: auto !important;
    font-family: monospace;
    font-size: 14px;
    line-height: 18px !important;
  }
}

.k-froala-plain-text.fr-box.fr-basic .fr-element.fr-view {
  font-family: monospace !important;
  font-size: 14px !important;
}

.k-case-item-importer-raw-text-area-max {
  textarea {
    overflow: auto !important;
    font-family: monospace;
    font-size: 14px;
    line-height: 18px !important;
    height: calc(85vh - 180px);
    margin: 0 auto;
  }
}
</style>
